// AUTO-GENERATED FILE. Do not edit.
import { PokeNames } from "types/pokemon/poke-names";
import type { PokeData } from "types/pokemon/poke-data";
import { bulbasaur } from "./pokemon/bulbasaur";
import { ivysaur } from "./pokemon/ivysaur";
import { venusaur } from "./pokemon/venusaur";
import { charmander } from "./pokemon/charmander";
import { charmeleon } from "./pokemon/charmeleon";
import { charizard } from "./pokemon/charizard";
import { squirtle } from "./pokemon/squirtle";
import { wartortle } from "./pokemon/wartortle";
import { blastoise } from "./pokemon/blastoise";
import { caterpie } from "./pokemon/caterpie";
import { metapod } from "./pokemon/metapod";
import { butterfree } from "./pokemon/butterfree";
import { weedle } from "./pokemon/weedle";
import { kakuna } from "./pokemon/kakuna";
import { beedrill } from "./pokemon/beedrill";
import { pidgey } from "./pokemon/pidgey";
import { pidgeotto } from "./pokemon/pidgeotto";
import { pidgeot } from "./pokemon/pidgeot";
import { rattata } from "./pokemon/rattata";
import { raticate } from "./pokemon/raticate";
import { spearow } from "./pokemon/spearow";
import { fearow } from "./pokemon/fearow";
import { ekans } from "./pokemon/ekans";
import { arbok } from "./pokemon/arbok";
import { pikachu } from "./pokemon/pikachu";
import { raichu } from "./pokemon/raichu";
import { sandshrew } from "./pokemon/sandshrew";
import { sandslash } from "./pokemon/sandslash";
import { nidoran_f } from "./pokemon/nidoran-f";
import { nidorina } from "./pokemon/nidorina";
import { nidoqueen } from "./pokemon/nidoqueen";
import { nidoran_m } from "./pokemon/nidoran-m";
import { nidorino } from "./pokemon/nidorino";
import { nidoking } from "./pokemon/nidoking";
import { clefairy } from "./pokemon/clefairy";
import { clefable } from "./pokemon/clefable";
import { vulpix } from "./pokemon/vulpix";
import { ninetales } from "./pokemon/ninetales";
import { jigglypuff } from "./pokemon/jigglypuff";
import { wigglytuff } from "./pokemon/wigglytuff";
import { zubat } from "./pokemon/zubat";
import { golbat } from "./pokemon/golbat";
import { oddish } from "./pokemon/oddish";
import { gloom } from "./pokemon/gloom";
import { vileplume } from "./pokemon/vileplume";
import { paras } from "./pokemon/paras";
import { parasect } from "./pokemon/parasect";
import { venonat } from "./pokemon/venonat";
import { venomoth } from "./pokemon/venomoth";
import { diglett } from "./pokemon/diglett";
import { dugtrio } from "./pokemon/dugtrio";
import { meowth } from "./pokemon/meowth";
import { persian } from "./pokemon/persian";
import { psyduck } from "./pokemon/psyduck";
import { golduck } from "./pokemon/golduck";
import { mankey } from "./pokemon/mankey";
import { primeape } from "./pokemon/primeape";
import { growlithe } from "./pokemon/growlithe";
import { arcanine } from "./pokemon/arcanine";
import { poliwag } from "./pokemon/poliwag";
import { poliwhirl } from "./pokemon/poliwhirl";
import { poliwrath } from "./pokemon/poliwrath";
import { abra } from "./pokemon/abra";
import { kadabra } from "./pokemon/kadabra";
import { alakazam } from "./pokemon/alakazam";
import { machop } from "./pokemon/machop";
import { machoke } from "./pokemon/machoke";
import { machamp } from "./pokemon/machamp";
import { bellsprout } from "./pokemon/bellsprout";
import { weepinbell } from "./pokemon/weepinbell";
import { victreebel } from "./pokemon/victreebel";
import { tentacool } from "./pokemon/tentacool";
import { tentacruel } from "./pokemon/tentacruel";
import { geodude } from "./pokemon/geodude";
import { graveler } from "./pokemon/graveler";
import { golem } from "./pokemon/golem";
import { ponyta } from "./pokemon/ponyta";
import { rapidash } from "./pokemon/rapidash";
import { slowpoke } from "./pokemon/slowpoke";
import { slowbro } from "./pokemon/slowbro";
import { magnemite } from "./pokemon/magnemite";
import { magneton } from "./pokemon/magneton";
import { farfetchd } from "./pokemon/farfetchd";
import { doduo } from "./pokemon/doduo";
import { dodrio } from "./pokemon/dodrio";
import { seel } from "./pokemon/seel";
import { dewgong } from "./pokemon/dewgong";
import { grimer } from "./pokemon/grimer";
import { muk } from "./pokemon/muk";
import { shellder } from "./pokemon/shellder";
import { cloyster } from "./pokemon/cloyster";
import { gastly } from "./pokemon/gastly";
import { haunter } from "./pokemon/haunter";
import { gengar } from "./pokemon/gengar";
import { onix } from "./pokemon/onix";
import { drowzee } from "./pokemon/drowzee";
import { hypno } from "./pokemon/hypno";
import { krabby } from "./pokemon/krabby";
import { kingler } from "./pokemon/kingler";
import { voltorb } from "./pokemon/voltorb";
import { electrode } from "./pokemon/electrode";
import { exeggcute } from "./pokemon/exeggcute";
import { exeggutor } from "./pokemon/exeggutor";
import { cubone } from "./pokemon/cubone";
import { marowak } from "./pokemon/marowak";
import { hitmonlee } from "./pokemon/hitmonlee";
import { hitmonchan } from "./pokemon/hitmonchan";
import { lickitung } from "./pokemon/lickitung";
import { koffing } from "./pokemon/koffing";
import { weezing } from "./pokemon/weezing";
import { rhyhorn } from "./pokemon/rhyhorn";
import { rhydon } from "./pokemon/rhydon";
import { chansey } from "./pokemon/chansey";
import { tangela } from "./pokemon/tangela";
import { kangaskhan } from "./pokemon/kangaskhan";
import { horsea } from "./pokemon/horsea";
import { seadra } from "./pokemon/seadra";
import { goldeen } from "./pokemon/goldeen";
import { seaking } from "./pokemon/seaking";
import { staryu } from "./pokemon/staryu";
import { starmie } from "./pokemon/starmie";
import { mr_mime } from "./pokemon/mr-mime";
import { scyther } from "./pokemon/scyther";
import { jynx } from "./pokemon/jynx";
import { electabuzz } from "./pokemon/electabuzz";
import { magmar } from "./pokemon/magmar";
import { pinsir } from "./pokemon/pinsir";
import { tauros } from "./pokemon/tauros";
import { magikarp } from "./pokemon/magikarp";
import { gyarados } from "./pokemon/gyarados";
import { lapras } from "./pokemon/lapras";
import { ditto } from "./pokemon/ditto";
import { eevee } from "./pokemon/eevee";
import { vaporeon } from "./pokemon/vaporeon";
import { jolteon } from "./pokemon/jolteon";
import { flareon } from "./pokemon/flareon";
import { porygon } from "./pokemon/porygon";
import { omanyte } from "./pokemon/omanyte";
import { omastar } from "./pokemon/omastar";
import { kabuto } from "./pokemon/kabuto";
import { kabutops } from "./pokemon/kabutops";
import { aerodactyl } from "./pokemon/aerodactyl";
import { snorlax } from "./pokemon/snorlax";
import { articuno } from "./pokemon/articuno";
import { zapdos } from "./pokemon/zapdos";
import { moltres } from "./pokemon/moltres";
import { dratini } from "./pokemon/dratini";
import { dragonair } from "./pokemon/dragonair";
import { dragonite } from "./pokemon/dragonite";
import { mewtwo } from "./pokemon/mewtwo";
import { mew } from "./pokemon/mew";
import { chikorita } from "./pokemon/chikorita";
import { bayleef } from "./pokemon/bayleef";
import { meganium } from "./pokemon/meganium";
import { cyndaquil } from "./pokemon/cyndaquil";
import { quilava } from "./pokemon/quilava";
import { typhlosion } from "./pokemon/typhlosion";
import { totodile } from "./pokemon/totodile";
import { croconaw } from "./pokemon/croconaw";
import { feraligatr } from "./pokemon/feraligatr";
import { sentret } from "./pokemon/sentret";
import { furret } from "./pokemon/furret";
import { hoothoot } from "./pokemon/hoothoot";
import { noctowl } from "./pokemon/noctowl";
import { ledyba } from "./pokemon/ledyba";
import { ledian } from "./pokemon/ledian";
import { spinarak } from "./pokemon/spinarak";
import { ariados } from "./pokemon/ariados";
import { crobat } from "./pokemon/crobat";
import { chinchou } from "./pokemon/chinchou";
import { lanturn } from "./pokemon/lanturn";
import { pichu } from "./pokemon/pichu";
import { cleffa } from "./pokemon/cleffa";
import { igglybuff } from "./pokemon/igglybuff";
import { togepi } from "./pokemon/togepi";
import { togetic } from "./pokemon/togetic";
import { natu } from "./pokemon/natu";
import { xatu } from "./pokemon/xatu";
import { mareep } from "./pokemon/mareep";
import { flaaffy } from "./pokemon/flaaffy";
import { ampharos } from "./pokemon/ampharos";
import { bellossom } from "./pokemon/bellossom";
import { marill } from "./pokemon/marill";
import { azumarill } from "./pokemon/azumarill";
import { sudowoodo } from "./pokemon/sudowoodo";
import { politoed } from "./pokemon/politoed";
import { hoppip } from "./pokemon/hoppip";
import { skiploom } from "./pokemon/skiploom";
import { jumpluff } from "./pokemon/jumpluff";
import { aipom } from "./pokemon/aipom";
import { sunkern } from "./pokemon/sunkern";
import { sunflora } from "./pokemon/sunflora";
import { yanma } from "./pokemon/yanma";
import { wooper } from "./pokemon/wooper";
import { quagsire } from "./pokemon/quagsire";
import { espeon } from "./pokemon/espeon";
import { umbreon } from "./pokemon/umbreon";
import { murkrow } from "./pokemon/murkrow";
import { slowking } from "./pokemon/slowking";
import { misdreavus } from "./pokemon/misdreavus";
import { unown } from "./pokemon/unown";
import { wobbuffet } from "./pokemon/wobbuffet";
import { girafarig } from "./pokemon/girafarig";
import { pineco } from "./pokemon/pineco";
import { forretress } from "./pokemon/forretress";
import { dunsparce } from "./pokemon/dunsparce";
import { gligar } from "./pokemon/gligar";
import { steelix } from "./pokemon/steelix";
import { snubbull } from "./pokemon/snubbull";
import { granbull } from "./pokemon/granbull";
import { qwilfish } from "./pokemon/qwilfish";
import { scizor } from "./pokemon/scizor";
import { shuckle } from "./pokemon/shuckle";
import { heracross } from "./pokemon/heracross";
import { sneasel } from "./pokemon/sneasel";
import { teddiursa } from "./pokemon/teddiursa";
import { ursaring } from "./pokemon/ursaring";
import { slugma } from "./pokemon/slugma";
import { magcargo } from "./pokemon/magcargo";
import { swinub } from "./pokemon/swinub";
import { piloswine } from "./pokemon/piloswine";
import { corsola } from "./pokemon/corsola";
import { remoraid } from "./pokemon/remoraid";
import { octillery } from "./pokemon/octillery";
import { delibird } from "./pokemon/delibird";
import { mantine } from "./pokemon/mantine";
import { skarmory } from "./pokemon/skarmory";
import { houndour } from "./pokemon/houndour";
import { houndoom } from "./pokemon/houndoom";
import { kingdra } from "./pokemon/kingdra";
import { phanpy } from "./pokemon/phanpy";
import { donphan } from "./pokemon/donphan";
import { porygon2 } from "./pokemon/porygon2";
import { stantler } from "./pokemon/stantler";
import { smeargle } from "./pokemon/smeargle";
import { tyrogue } from "./pokemon/tyrogue";
import { hitmontop } from "./pokemon/hitmontop";
import { smoochum } from "./pokemon/smoochum";
import { elekid } from "./pokemon/elekid";
import { magby } from "./pokemon/magby";
import { miltank } from "./pokemon/miltank";
import { blissey } from "./pokemon/blissey";
import { raikou } from "./pokemon/raikou";
import { entei } from "./pokemon/entei";
import { suicune } from "./pokemon/suicune";
import { larvitar } from "./pokemon/larvitar";
import { pupitar } from "./pokemon/pupitar";
import { tyranitar } from "./pokemon/tyranitar";
import { lugia } from "./pokemon/lugia";
import { ho_oh } from "./pokemon/ho-oh";
import { celebi } from "./pokemon/celebi";
import { treecko } from "./pokemon/treecko";
import { grovyle } from "./pokemon/grovyle";
import { sceptile } from "./pokemon/sceptile";
import { torchic } from "./pokemon/torchic";
import { combusken } from "./pokemon/combusken";
import { blaziken } from "./pokemon/blaziken";
import { mudkip } from "./pokemon/mudkip";
import { marshtomp } from "./pokemon/marshtomp";
import { swampert } from "./pokemon/swampert";
import { poochyena } from "./pokemon/poochyena";
import { mightyena } from "./pokemon/mightyena";
import { zigzagoon } from "./pokemon/zigzagoon";
import { linoone } from "./pokemon/linoone";
import { wurmple } from "./pokemon/wurmple";
import { silcoon } from "./pokemon/silcoon";
import { beautifly } from "./pokemon/beautifly";
import { cascoon } from "./pokemon/cascoon";
import { dustox } from "./pokemon/dustox";
import { lotad } from "./pokemon/lotad";
import { lombre } from "./pokemon/lombre";
import { ludicolo } from "./pokemon/ludicolo";
import { seedot } from "./pokemon/seedot";
import { nuzleaf } from "./pokemon/nuzleaf";
import { shiftry } from "./pokemon/shiftry";
import { taillow } from "./pokemon/taillow";
import { swellow } from "./pokemon/swellow";
import { wingull } from "./pokemon/wingull";
import { pelipper } from "./pokemon/pelipper";
import { ralts } from "./pokemon/ralts";
import { kirlia } from "./pokemon/kirlia";
import { gardevoir } from "./pokemon/gardevoir";
import { surskit } from "./pokemon/surskit";
import { masquerain } from "./pokemon/masquerain";
import { shroomish } from "./pokemon/shroomish";
import { breloom } from "./pokemon/breloom";
import { slakoth } from "./pokemon/slakoth";
import { vigoroth } from "./pokemon/vigoroth";
import { slaking } from "./pokemon/slaking";
import { nincada } from "./pokemon/nincada";
import { ninjask } from "./pokemon/ninjask";
import { shedinja } from "./pokemon/shedinja";
import { whismur } from "./pokemon/whismur";
import { loudred } from "./pokemon/loudred";
import { exploud } from "./pokemon/exploud";
import { makuhita } from "./pokemon/makuhita";
import { hariyama } from "./pokemon/hariyama";
import { azurill } from "./pokemon/azurill";
import { nosepass } from "./pokemon/nosepass";
import { skitty } from "./pokemon/skitty";
import { delcatty } from "./pokemon/delcatty";
import { sableye } from "./pokemon/sableye";
import { mawile } from "./pokemon/mawile";
import { aron } from "./pokemon/aron";
import { lairon } from "./pokemon/lairon";
import { aggron } from "./pokemon/aggron";
import { meditite } from "./pokemon/meditite";
import { medicham } from "./pokemon/medicham";
import { electrike } from "./pokemon/electrike";
import { manectric } from "./pokemon/manectric";
import { plusle } from "./pokemon/plusle";
import { minun } from "./pokemon/minun";
import { volbeat } from "./pokemon/volbeat";
import { illumise } from "./pokemon/illumise";
import { roselia } from "./pokemon/roselia";
import { gulpin } from "./pokemon/gulpin";
import { swalot } from "./pokemon/swalot";
import { carvanha } from "./pokemon/carvanha";
import { sharpedo } from "./pokemon/sharpedo";
import { wailmer } from "./pokemon/wailmer";
import { wailord } from "./pokemon/wailord";
import { numel } from "./pokemon/numel";
import { camerupt } from "./pokemon/camerupt";
import { torkoal } from "./pokemon/torkoal";
import { spoink } from "./pokemon/spoink";
import { grumpig } from "./pokemon/grumpig";
import { spinda } from "./pokemon/spinda";
import { trapinch } from "./pokemon/trapinch";
import { vibrava } from "./pokemon/vibrava";
import { flygon } from "./pokemon/flygon";
import { cacnea } from "./pokemon/cacnea";
import { cacturne } from "./pokemon/cacturne";
import { swablu } from "./pokemon/swablu";
import { altaria } from "./pokemon/altaria";
import { zangoose } from "./pokemon/zangoose";
import { seviper } from "./pokemon/seviper";
import { lunatone } from "./pokemon/lunatone";
import { solrock } from "./pokemon/solrock";
import { barboach } from "./pokemon/barboach";
import { whiscash } from "./pokemon/whiscash";
import { corphish } from "./pokemon/corphish";
import { crawdaunt } from "./pokemon/crawdaunt";
import { baltoy } from "./pokemon/baltoy";
import { claydol } from "./pokemon/claydol";
import { lileep } from "./pokemon/lileep";
import { cradily } from "./pokemon/cradily";
import { anorith } from "./pokemon/anorith";
import { armaldo } from "./pokemon/armaldo";
import { feebas } from "./pokemon/feebas";
import { milotic } from "./pokemon/milotic";
import { castform } from "./pokemon/castform";
import { kecleon } from "./pokemon/kecleon";
import { shuppet } from "./pokemon/shuppet";
import { banette } from "./pokemon/banette";
import { duskull } from "./pokemon/duskull";
import { dusclops } from "./pokemon/dusclops";
import { tropius } from "./pokemon/tropius";
import { chimecho } from "./pokemon/chimecho";
import { absol } from "./pokemon/absol";
import { wynaut } from "./pokemon/wynaut";
import { snorunt } from "./pokemon/snorunt";
import { glalie } from "./pokemon/glalie";
import { spheal } from "./pokemon/spheal";
import { sealeo } from "./pokemon/sealeo";
import { walrein } from "./pokemon/walrein";
import { clamperl } from "./pokemon/clamperl";
import { huntail } from "./pokemon/huntail";
import { gorebyss } from "./pokemon/gorebyss";
import { relicanth } from "./pokemon/relicanth";
import { luvdisc } from "./pokemon/luvdisc";
import { bagon } from "./pokemon/bagon";
import { shelgon } from "./pokemon/shelgon";
import { salamence } from "./pokemon/salamence";
import { beldum } from "./pokemon/beldum";
import { metang } from "./pokemon/metang";
import { metagross } from "./pokemon/metagross";
import { regirock } from "./pokemon/regirock";
import { regice } from "./pokemon/regice";
import { registeel } from "./pokemon/registeel";
import { latias } from "./pokemon/latias";
import { latios } from "./pokemon/latios";
import { kyogre } from "./pokemon/kyogre";
import { groudon } from "./pokemon/groudon";
import { rayquaza } from "./pokemon/rayquaza";
import { jirachi } from "./pokemon/jirachi";
import { deoxys_normal } from "./pokemon/deoxys-normal";
import { turtwig } from "./pokemon/turtwig";
import { grotle } from "./pokemon/grotle";
import { torterra } from "./pokemon/torterra";
import { chimchar } from "./pokemon/chimchar";
import { monferno } from "./pokemon/monferno";
import { infernape } from "./pokemon/infernape";
import { piplup } from "./pokemon/piplup";
import { prinplup } from "./pokemon/prinplup";
import { empoleon } from "./pokemon/empoleon";
import { starly } from "./pokemon/starly";
import { staravia } from "./pokemon/staravia";
import { staraptor } from "./pokemon/staraptor";
import { bidoof } from "./pokemon/bidoof";
import { bibarel } from "./pokemon/bibarel";
import { kricketot } from "./pokemon/kricketot";
import { kricketune } from "./pokemon/kricketune";
import { shinx } from "./pokemon/shinx";
import { luxio } from "./pokemon/luxio";
import { luxray } from "./pokemon/luxray";
import { budew } from "./pokemon/budew";
import { roserade } from "./pokemon/roserade";
import { cranidos } from "./pokemon/cranidos";
import { rampardos } from "./pokemon/rampardos";
import { shieldon } from "./pokemon/shieldon";
import { bastiodon } from "./pokemon/bastiodon";
import { burmy } from "./pokemon/burmy";
import { wormadam_plant } from "./pokemon/wormadam-plant";
import { mothim } from "./pokemon/mothim";
import { combee } from "./pokemon/combee";
import { vespiquen } from "./pokemon/vespiquen";
import { pachirisu } from "./pokemon/pachirisu";
import { buizel } from "./pokemon/buizel";
import { floatzel } from "./pokemon/floatzel";
import { cherubi } from "./pokemon/cherubi";
import { cherrim } from "./pokemon/cherrim";
import { shellos } from "./pokemon/shellos";
import { gastrodon } from "./pokemon/gastrodon";
import { ambipom } from "./pokemon/ambipom";
import { drifloon } from "./pokemon/drifloon";
import { drifblim } from "./pokemon/drifblim";
import { buneary } from "./pokemon/buneary";
import { lopunny } from "./pokemon/lopunny";
import { mismagius } from "./pokemon/mismagius";
import { honchkrow } from "./pokemon/honchkrow";
import { glameow } from "./pokemon/glameow";
import { purugly } from "./pokemon/purugly";
import { chingling } from "./pokemon/chingling";
import { stunky } from "./pokemon/stunky";
import { skuntank } from "./pokemon/skuntank";
import { bronzor } from "./pokemon/bronzor";
import { bronzong } from "./pokemon/bronzong";
import { bonsly } from "./pokemon/bonsly";
import { mime_jr } from "./pokemon/mime-jr";
import { happiny } from "./pokemon/happiny";
import { chatot } from "./pokemon/chatot";
import { spiritomb } from "./pokemon/spiritomb";
import { gible } from "./pokemon/gible";
import { gabite } from "./pokemon/gabite";
import { garchomp } from "./pokemon/garchomp";
import { munchlax } from "./pokemon/munchlax";
import { riolu } from "./pokemon/riolu";
import { lucario } from "./pokemon/lucario";
import { hippopotas } from "./pokemon/hippopotas";
import { hippowdon } from "./pokemon/hippowdon";
import { skorupi } from "./pokemon/skorupi";
import { drapion } from "./pokemon/drapion";
import { croagunk } from "./pokemon/croagunk";
import { toxicroak } from "./pokemon/toxicroak";
import { carnivine } from "./pokemon/carnivine";
import { finneon } from "./pokemon/finneon";
import { lumineon } from "./pokemon/lumineon";
import { mantyke } from "./pokemon/mantyke";
import { snover } from "./pokemon/snover";
import { abomasnow } from "./pokemon/abomasnow";
import { weavile } from "./pokemon/weavile";
import { magnezone } from "./pokemon/magnezone";
import { lickilicky } from "./pokemon/lickilicky";
import { rhyperior } from "./pokemon/rhyperior";
import { tangrowth } from "./pokemon/tangrowth";
import { electivire } from "./pokemon/electivire";
import { magmortar } from "./pokemon/magmortar";
import { togekiss } from "./pokemon/togekiss";
import { yanmega } from "./pokemon/yanmega";
import { leafeon } from "./pokemon/leafeon";
import { glaceon } from "./pokemon/glaceon";
import { gliscor } from "./pokemon/gliscor";
import { mamoswine } from "./pokemon/mamoswine";
import { porygon_z } from "./pokemon/porygon-z";
import { gallade } from "./pokemon/gallade";
import { probopass } from "./pokemon/probopass";
import { dusknoir } from "./pokemon/dusknoir";
import { froslass } from "./pokemon/froslass";
import { rotom } from "./pokemon/rotom";
import { uxie } from "./pokemon/uxie";
import { mesprit } from "./pokemon/mesprit";
import { azelf } from "./pokemon/azelf";
import { dialga } from "./pokemon/dialga";
import { palkia } from "./pokemon/palkia";
import { heatran } from "./pokemon/heatran";
import { regigigas } from "./pokemon/regigigas";
import { giratina_altered } from "./pokemon/giratina-altered";
import { cresselia } from "./pokemon/cresselia";
import { phione } from "./pokemon/phione";
import { manaphy } from "./pokemon/manaphy";
import { darkrai } from "./pokemon/darkrai";
import { shaymin_land } from "./pokemon/shaymin-land";
import { arceus } from "./pokemon/arceus";
import { victini } from "./pokemon/victini";
import { snivy } from "./pokemon/snivy";
import { servine } from "./pokemon/servine";
import { serperior } from "./pokemon/serperior";
import { tepig } from "./pokemon/tepig";
import { pignite } from "./pokemon/pignite";
import { emboar } from "./pokemon/emboar";
import { oshawott } from "./pokemon/oshawott";
import { dewott } from "./pokemon/dewott";
import { samurott } from "./pokemon/samurott";
import { patrat } from "./pokemon/patrat";
import { watchog } from "./pokemon/watchog";
import { lillipup } from "./pokemon/lillipup";
import { herdier } from "./pokemon/herdier";
import { stoutland } from "./pokemon/stoutland";
import { purrloin } from "./pokemon/purrloin";
import { liepard } from "./pokemon/liepard";
import { pansage } from "./pokemon/pansage";
import { simisage } from "./pokemon/simisage";
import { pansear } from "./pokemon/pansear";
import { simisear } from "./pokemon/simisear";
import { panpour } from "./pokemon/panpour";
import { simipour } from "./pokemon/simipour";
import { munna } from "./pokemon/munna";
import { musharna } from "./pokemon/musharna";
import { pidove } from "./pokemon/pidove";
import { tranquill } from "./pokemon/tranquill";
import { unfezant } from "./pokemon/unfezant";
import { blitzle } from "./pokemon/blitzle";
import { zebstrika } from "./pokemon/zebstrika";
import { roggenrola } from "./pokemon/roggenrola";
import { boldore } from "./pokemon/boldore";
import { gigalith } from "./pokemon/gigalith";
import { woobat } from "./pokemon/woobat";
import { swoobat } from "./pokemon/swoobat";
import { drilbur } from "./pokemon/drilbur";
import { excadrill } from "./pokemon/excadrill";
import { audino } from "./pokemon/audino";
import { timburr } from "./pokemon/timburr";
import { gurdurr } from "./pokemon/gurdurr";
import { conkeldurr } from "./pokemon/conkeldurr";
import { tympole } from "./pokemon/tympole";
import { palpitoad } from "./pokemon/palpitoad";
import { seismitoad } from "./pokemon/seismitoad";
import { throh } from "./pokemon/throh";
import { sawk } from "./pokemon/sawk";
import { sewaddle } from "./pokemon/sewaddle";
import { swadloon } from "./pokemon/swadloon";
import { leavanny } from "./pokemon/leavanny";
import { venipede } from "./pokemon/venipede";
import { whirlipede } from "./pokemon/whirlipede";
import { scolipede } from "./pokemon/scolipede";
import { cottonee } from "./pokemon/cottonee";
import { whimsicott } from "./pokemon/whimsicott";
import { petilil } from "./pokemon/petilil";
import { lilligant } from "./pokemon/lilligant";
import { basculin_red_striped } from "./pokemon/basculin-red-striped";
import { sandile } from "./pokemon/sandile";
import { krokorok } from "./pokemon/krokorok";
import { krookodile } from "./pokemon/krookodile";
import { darumaka } from "./pokemon/darumaka";
import { darmanitan_standard } from "./pokemon/darmanitan-standard";
import { maractus } from "./pokemon/maractus";
import { dwebble } from "./pokemon/dwebble";
import { crustle } from "./pokemon/crustle";
import { scraggy } from "./pokemon/scraggy";
import { scrafty } from "./pokemon/scrafty";
import { sigilyph } from "./pokemon/sigilyph";
import { yamask } from "./pokemon/yamask";
import { cofagrigus } from "./pokemon/cofagrigus";
import { tirtouga } from "./pokemon/tirtouga";
import { carracosta } from "./pokemon/carracosta";
import { archen } from "./pokemon/archen";
import { archeops } from "./pokemon/archeops";
import { trubbish } from "./pokemon/trubbish";
import { garbodor } from "./pokemon/garbodor";
import { zorua } from "./pokemon/zorua";
import { zoroark } from "./pokemon/zoroark";
import { minccino } from "./pokemon/minccino";
import { cinccino } from "./pokemon/cinccino";
import { gothita } from "./pokemon/gothita";
import { gothorita } from "./pokemon/gothorita";
import { gothitelle } from "./pokemon/gothitelle";
import { solosis } from "./pokemon/solosis";
import { duosion } from "./pokemon/duosion";
import { reuniclus } from "./pokemon/reuniclus";
import { ducklett } from "./pokemon/ducklett";
import { swanna } from "./pokemon/swanna";
import { vanillite } from "./pokemon/vanillite";
import { vanillish } from "./pokemon/vanillish";
import { vanilluxe } from "./pokemon/vanilluxe";
import { deerling } from "./pokemon/deerling";
import { sawsbuck } from "./pokemon/sawsbuck";
import { emolga } from "./pokemon/emolga";
import { karrablast } from "./pokemon/karrablast";
import { escavalier } from "./pokemon/escavalier";
import { foongus } from "./pokemon/foongus";
import { amoonguss } from "./pokemon/amoonguss";
import { frillish } from "./pokemon/frillish";
import { jellicent } from "./pokemon/jellicent";
import { alomomola } from "./pokemon/alomomola";
import { joltik } from "./pokemon/joltik";
import { galvantula } from "./pokemon/galvantula";
import { ferroseed } from "./pokemon/ferroseed";
import { ferrothorn } from "./pokemon/ferrothorn";
import { klink } from "./pokemon/klink";
import { klang } from "./pokemon/klang";
import { klinklang } from "./pokemon/klinklang";
import { tynamo } from "./pokemon/tynamo";
import { eelektrik } from "./pokemon/eelektrik";
import { eelektross } from "./pokemon/eelektross";
import { elgyem } from "./pokemon/elgyem";
import { beheeyem } from "./pokemon/beheeyem";
import { litwick } from "./pokemon/litwick";
import { lampent } from "./pokemon/lampent";
import { chandelure } from "./pokemon/chandelure";
import { axew } from "./pokemon/axew";
import { fraxure } from "./pokemon/fraxure";
import { haxorus } from "./pokemon/haxorus";
import { cubchoo } from "./pokemon/cubchoo";
import { beartic } from "./pokemon/beartic";
import { cryogonal } from "./pokemon/cryogonal";
import { shelmet } from "./pokemon/shelmet";
import { accelgor } from "./pokemon/accelgor";
import { stunfisk } from "./pokemon/stunfisk";
import { mienfoo } from "./pokemon/mienfoo";
import { mienshao } from "./pokemon/mienshao";
import { druddigon } from "./pokemon/druddigon";
import { golett } from "./pokemon/golett";
import { golurk } from "./pokemon/golurk";
import { pawniard } from "./pokemon/pawniard";
import { bisharp } from "./pokemon/bisharp";
import { bouffalant } from "./pokemon/bouffalant";
import { rufflet } from "./pokemon/rufflet";
import { braviary } from "./pokemon/braviary";
import { vullaby } from "./pokemon/vullaby";
import { mandibuzz } from "./pokemon/mandibuzz";
import { heatmor } from "./pokemon/heatmor";
import { durant } from "./pokemon/durant";
import { deino } from "./pokemon/deino";
import { zweilous } from "./pokemon/zweilous";
import { hydreigon } from "./pokemon/hydreigon";
import { larvesta } from "./pokemon/larvesta";
import { volcarona } from "./pokemon/volcarona";
import { cobalion } from "./pokemon/cobalion";
import { terrakion } from "./pokemon/terrakion";
import { virizion } from "./pokemon/virizion";
import { tornadus_incarnate } from "./pokemon/tornadus-incarnate";
import { thundurus_incarnate } from "./pokemon/thundurus-incarnate";
import { reshiram } from "./pokemon/reshiram";
import { zekrom } from "./pokemon/zekrom";
import { landorus_incarnate } from "./pokemon/landorus-incarnate";
import { kyurem } from "./pokemon/kyurem";
import { keldeo_ordinary } from "./pokemon/keldeo-ordinary";
import { meloetta_aria } from "./pokemon/meloetta-aria";
import { genesect } from "./pokemon/genesect";
import { chespin } from "./pokemon/chespin";
import { quilladin } from "./pokemon/quilladin";
import { chesnaught } from "./pokemon/chesnaught";
import { fennekin } from "./pokemon/fennekin";
import { braixen } from "./pokemon/braixen";
import { delphox } from "./pokemon/delphox";
import { froakie } from "./pokemon/froakie";
import { frogadier } from "./pokemon/frogadier";
import { greninja } from "./pokemon/greninja";
import { bunnelby } from "./pokemon/bunnelby";
import { diggersby } from "./pokemon/diggersby";
import { fletchling } from "./pokemon/fletchling";
import { fletchinder } from "./pokemon/fletchinder";
import { talonflame } from "./pokemon/talonflame";
import { scatterbug } from "./pokemon/scatterbug";
import { spewpa } from "./pokemon/spewpa";
import { vivillon } from "./pokemon/vivillon";
import { litleo } from "./pokemon/litleo";
import { pyroar } from "./pokemon/pyroar";
import { flabebe } from "./pokemon/flabebe";
import { floette } from "./pokemon/floette";
import { florges } from "./pokemon/florges";
import { skiddo } from "./pokemon/skiddo";
import { gogoat } from "./pokemon/gogoat";
import { pancham } from "./pokemon/pancham";
import { pangoro } from "./pokemon/pangoro";
import { furfrou } from "./pokemon/furfrou";
import { espurr } from "./pokemon/espurr";
import { meowstic_male } from "./pokemon/meowstic-male";
import { honedge } from "./pokemon/honedge";
import { doublade } from "./pokemon/doublade";
import { aegislash_shield } from "./pokemon/aegislash-shield";
import { spritzee } from "./pokemon/spritzee";
import { aromatisse } from "./pokemon/aromatisse";
import { swirlix } from "./pokemon/swirlix";
import { slurpuff } from "./pokemon/slurpuff";
import { inkay } from "./pokemon/inkay";
import { malamar } from "./pokemon/malamar";
import { binacle } from "./pokemon/binacle";
import { barbaracle } from "./pokemon/barbaracle";
import { skrelp } from "./pokemon/skrelp";
import { dragalge } from "./pokemon/dragalge";
import { clauncher } from "./pokemon/clauncher";
import { clawitzer } from "./pokemon/clawitzer";
import { helioptile } from "./pokemon/helioptile";
import { heliolisk } from "./pokemon/heliolisk";
import { tyrunt } from "./pokemon/tyrunt";
import { tyrantrum } from "./pokemon/tyrantrum";
import { amaura } from "./pokemon/amaura";
import { aurorus } from "./pokemon/aurorus";
import { sylveon } from "./pokemon/sylveon";
import { hawlucha } from "./pokemon/hawlucha";
import { dedenne } from "./pokemon/dedenne";
import { carbink } from "./pokemon/carbink";
import { goomy } from "./pokemon/goomy";
import { sliggoo } from "./pokemon/sliggoo";
import { goodra } from "./pokemon/goodra";
import { klefki } from "./pokemon/klefki";
import { phantump } from "./pokemon/phantump";
import { trevenant } from "./pokemon/trevenant";
import { pumpkaboo_average } from "./pokemon/pumpkaboo-average";
import { gourgeist_average } from "./pokemon/gourgeist-average";
import { bergmite } from "./pokemon/bergmite";
import { avalugg } from "./pokemon/avalugg";
import { noibat } from "./pokemon/noibat";
import { noivern } from "./pokemon/noivern";
import { xerneas } from "./pokemon/xerneas";
import { yveltal } from "./pokemon/yveltal";
import { zygarde_50 } from "./pokemon/zygarde-50";
import { diancie } from "./pokemon/diancie";
import { hoopa } from "./pokemon/hoopa";
import { volcanion } from "./pokemon/volcanion";
import { rowlet } from "./pokemon/rowlet";
import { dartrix } from "./pokemon/dartrix";
import { decidueye } from "./pokemon/decidueye";
import { litten } from "./pokemon/litten";
import { torracat } from "./pokemon/torracat";
import { incineroar } from "./pokemon/incineroar";
import { popplio } from "./pokemon/popplio";
import { brionne } from "./pokemon/brionne";
import { primarina } from "./pokemon/primarina";
import { pikipek } from "./pokemon/pikipek";
import { trumbeak } from "./pokemon/trumbeak";
import { toucannon } from "./pokemon/toucannon";
import { yungoos } from "./pokemon/yungoos";
import { gumshoos } from "./pokemon/gumshoos";
import { grubbin } from "./pokemon/grubbin";
import { charjabug } from "./pokemon/charjabug";
import { vikavolt } from "./pokemon/vikavolt";
import { crabrawler } from "./pokemon/crabrawler";
import { crabominable } from "./pokemon/crabominable";
import { oricorio_baile } from "./pokemon/oricorio-baile";
import { cutiefly } from "./pokemon/cutiefly";
import { ribombee } from "./pokemon/ribombee";
import { rockruff } from "./pokemon/rockruff";
import { lycanroc_midday } from "./pokemon/lycanroc-midday";
import { wishiwashi_solo } from "./pokemon/wishiwashi-solo";
import { mareanie } from "./pokemon/mareanie";
import { toxapex } from "./pokemon/toxapex";
import { mudbray } from "./pokemon/mudbray";
import { mudsdale } from "./pokemon/mudsdale";
import { dewpider } from "./pokemon/dewpider";
import { araquanid } from "./pokemon/araquanid";
import { fomantis } from "./pokemon/fomantis";
import { lurantis } from "./pokemon/lurantis";
import { morelull } from "./pokemon/morelull";
import { shiinotic } from "./pokemon/shiinotic";
import { salandit } from "./pokemon/salandit";
import { salazzle } from "./pokemon/salazzle";
import { stufful } from "./pokemon/stufful";
import { bewear } from "./pokemon/bewear";
import { bounsweet } from "./pokemon/bounsweet";
import { steenee } from "./pokemon/steenee";
import { tsareena } from "./pokemon/tsareena";
import { comfey } from "./pokemon/comfey";
import { oranguru } from "./pokemon/oranguru";
import { passimian } from "./pokemon/passimian";
import { wimpod } from "./pokemon/wimpod";
import { golisopod } from "./pokemon/golisopod";
import { sandygast } from "./pokemon/sandygast";
import { palossand } from "./pokemon/palossand";
import { pyukumuku } from "./pokemon/pyukumuku";
import { type_null } from "./pokemon/type-null";
import { silvally } from "./pokemon/silvally";
import { minior_red_meteor } from "./pokemon/minior-red-meteor";
import { komala } from "./pokemon/komala";
import { turtonator } from "./pokemon/turtonator";
import { togedemaru } from "./pokemon/togedemaru";
import { mimikyu_disguised } from "./pokemon/mimikyu-disguised";
import { bruxish } from "./pokemon/bruxish";
import { drampa } from "./pokemon/drampa";
import { dhelmise } from "./pokemon/dhelmise";
import { jangmo_o } from "./pokemon/jangmo-o";
import { hakamo_o } from "./pokemon/hakamo-o";
import { kommo_o } from "./pokemon/kommo-o";
import { tapu_koko } from "./pokemon/tapu-koko";
import { tapu_lele } from "./pokemon/tapu-lele";
import { tapu_bulu } from "./pokemon/tapu-bulu";
import { tapu_fini } from "./pokemon/tapu-fini";
import { cosmog } from "./pokemon/cosmog";
import { cosmoem } from "./pokemon/cosmoem";
import { solgaleo } from "./pokemon/solgaleo";
import { lunala } from "./pokemon/lunala";
import { nihilego } from "./pokemon/nihilego";
import { buzzwole } from "./pokemon/buzzwole";
import { pheromosa } from "./pokemon/pheromosa";
import { xurkitree } from "./pokemon/xurkitree";
import { celesteela } from "./pokemon/celesteela";
import { kartana } from "./pokemon/kartana";
import { guzzlord } from "./pokemon/guzzlord";
import { necrozma } from "./pokemon/necrozma";
import { magearna } from "./pokemon/magearna";
import { marshadow } from "./pokemon/marshadow";
import { poipole } from "./pokemon/poipole";
import { naganadel } from "./pokemon/naganadel";
import { stakataka } from "./pokemon/stakataka";
import { blacephalon } from "./pokemon/blacephalon";
import { zeraora } from "./pokemon/zeraora";
import { meltan } from "./pokemon/meltan";
import { melmetal } from "./pokemon/melmetal";
import { grookey } from "./pokemon/grookey";
import { thwackey } from "./pokemon/thwackey";
import { rillaboom } from "./pokemon/rillaboom";
import { scorbunny } from "./pokemon/scorbunny";
import { raboot } from "./pokemon/raboot";
import { cinderace } from "./pokemon/cinderace";
import { sobble } from "./pokemon/sobble";
import { drizzile } from "./pokemon/drizzile";
import { inteleon } from "./pokemon/inteleon";
import { skwovet } from "./pokemon/skwovet";
import { greedent } from "./pokemon/greedent";
import { rookidee } from "./pokemon/rookidee";
import { corvisquire } from "./pokemon/corvisquire";
import { corviknight } from "./pokemon/corviknight";
import { blipbug } from "./pokemon/blipbug";
import { dottler } from "./pokemon/dottler";
import { orbeetle } from "./pokemon/orbeetle";
import { nickit } from "./pokemon/nickit";
import { thievul } from "./pokemon/thievul";
import { gossifleur } from "./pokemon/gossifleur";
import { eldegoss } from "./pokemon/eldegoss";
import { wooloo } from "./pokemon/wooloo";
import { dubwool } from "./pokemon/dubwool";
import { chewtle } from "./pokemon/chewtle";
import { drednaw } from "./pokemon/drednaw";
import { yamper } from "./pokemon/yamper";
import { boltund } from "./pokemon/boltund";
import { rolycoly } from "./pokemon/rolycoly";
import { carkol } from "./pokemon/carkol";
import { coalossal } from "./pokemon/coalossal";
import { applin } from "./pokemon/applin";
import { flapple } from "./pokemon/flapple";
import { appletun } from "./pokemon/appletun";
import { silicobra } from "./pokemon/silicobra";
import { sandaconda } from "./pokemon/sandaconda";
import { cramorant } from "./pokemon/cramorant";
import { arrokuda } from "./pokemon/arrokuda";
import { barraskewda } from "./pokemon/barraskewda";
import { toxel } from "./pokemon/toxel";
import { toxtricity_amped } from "./pokemon/toxtricity-amped";
import { sizzlipede } from "./pokemon/sizzlipede";
import { centiskorch } from "./pokemon/centiskorch";
import { clobbopus } from "./pokemon/clobbopus";
import { grapploct } from "./pokemon/grapploct";
import { sinistea } from "./pokemon/sinistea";
import { polteageist } from "./pokemon/polteageist";
import { hatenna } from "./pokemon/hatenna";
import { hattrem } from "./pokemon/hattrem";
import { hatterene } from "./pokemon/hatterene";
import { impidimp } from "./pokemon/impidimp";
import { morgrem } from "./pokemon/morgrem";
import { grimmsnarl } from "./pokemon/grimmsnarl";
import { obstagoon } from "./pokemon/obstagoon";
import { perrserker } from "./pokemon/perrserker";
import { cursola } from "./pokemon/cursola";
import { sirfetchd } from "./pokemon/sirfetchd";
import { mr_rime } from "./pokemon/mr-rime";
import { runerigus } from "./pokemon/runerigus";
import { milcery } from "./pokemon/milcery";
import { alcremie } from "./pokemon/alcremie";
import { falinks } from "./pokemon/falinks";
import { pincurchin } from "./pokemon/pincurchin";
import { snom } from "./pokemon/snom";
import { frosmoth } from "./pokemon/frosmoth";
import { stonjourner } from "./pokemon/stonjourner";
import { eiscue_ice } from "./pokemon/eiscue-ice";
import { indeedee_male } from "./pokemon/indeedee-male";
import { morpeko_full_belly } from "./pokemon/morpeko-full-belly";
import { cufant } from "./pokemon/cufant";
import { copperajah } from "./pokemon/copperajah";
import { dracozolt } from "./pokemon/dracozolt";
import { arctozolt } from "./pokemon/arctozolt";
import { dracovish } from "./pokemon/dracovish";
import { arctovish } from "./pokemon/arctovish";
import { duraludon } from "./pokemon/duraludon";
import { dreepy } from "./pokemon/dreepy";
import { drakloak } from "./pokemon/drakloak";
import { dragapult } from "./pokemon/dragapult";
import { zacian } from "./pokemon/zacian";
import { zamazenta } from "./pokemon/zamazenta";
import { eternatus } from "./pokemon/eternatus";
import { kubfu } from "./pokemon/kubfu";
import { urshifu_single_strike } from "./pokemon/urshifu-single-strike";
import { zarude } from "./pokemon/zarude";
import { regieleki } from "./pokemon/regieleki";
import { regidrago } from "./pokemon/regidrago";
import { glastrier } from "./pokemon/glastrier";
import { spectrier } from "./pokemon/spectrier";
import { calyrex } from "./pokemon/calyrex";
import { wyrdeer } from "./pokemon/wyrdeer";
import { kleavor } from "./pokemon/kleavor";
import { ursaluna } from "./pokemon/ursaluna";
import { basculegion_male } from "./pokemon/basculegion-male";
import { sneasler } from "./pokemon/sneasler";
import { overqwil } from "./pokemon/overqwil";
import { enamorus_incarnate } from "./pokemon/enamorus-incarnate";
import { sprigatito } from "./pokemon/sprigatito";
import { floragato } from "./pokemon/floragato";
import { meowscarada } from "./pokemon/meowscarada";
import { fuecoco } from "./pokemon/fuecoco";
import { crocalor } from "./pokemon/crocalor";
import { skeledirge } from "./pokemon/skeledirge";
import { quaxly } from "./pokemon/quaxly";
import { quaxwell } from "./pokemon/quaxwell";
import { quaquaval } from "./pokemon/quaquaval";
import { lechonk } from "./pokemon/lechonk";
import { oinkologne_male } from "./pokemon/oinkologne-male";
import { tarountula } from "./pokemon/tarountula";
import { spidops } from "./pokemon/spidops";
import { nymble } from "./pokemon/nymble";
import { lokix } from "./pokemon/lokix";
import { pawmi } from "./pokemon/pawmi";
import { pawmo } from "./pokemon/pawmo";
import { pawmot } from "./pokemon/pawmot";
import { tandemaus } from "./pokemon/tandemaus";
import { maushold } from "./pokemon/maushold";
import { fidough } from "./pokemon/fidough";
import { dachsbun } from "./pokemon/dachsbun";
import { smoliv } from "./pokemon/smoliv";
import { dolliv } from "./pokemon/dolliv";
import { arboliva } from "./pokemon/arboliva";
import { squawkabilly_green_plumage } from "./pokemon/squawkabilly-green-plumage";
import { nacli } from "./pokemon/nacli";
import { naclstack } from "./pokemon/naclstack";
import { garganacl } from "./pokemon/garganacl";
import { charcadet } from "./pokemon/charcadet";
import { armarouge } from "./pokemon/armarouge";
import { ceruledge } from "./pokemon/ceruledge";
import { tadbulb } from "./pokemon/tadbulb";
import { bellibolt } from "./pokemon/bellibolt";
import { wattrel } from "./pokemon/wattrel";
import { kilowattrel } from "./pokemon/kilowattrel";
import { maschiff } from "./pokemon/maschiff";
import { mabosstiff } from "./pokemon/mabosstiff";
import { shroodle } from "./pokemon/shroodle";
import { grafaiai } from "./pokemon/grafaiai";
import { bramblin } from "./pokemon/bramblin";
import { brambleghast } from "./pokemon/brambleghast";
import { toedscool } from "./pokemon/toedscool";
import { toedscruel } from "./pokemon/toedscruel";
import { klawf } from "./pokemon/klawf";
import { capsakid } from "./pokemon/capsakid";
import { scovillain } from "./pokemon/scovillain";
import { rellor } from "./pokemon/rellor";
import { rabsca } from "./pokemon/rabsca";
import { flittle } from "./pokemon/flittle";
import { espathra } from "./pokemon/espathra";
import { tinkatink } from "./pokemon/tinkatink";
import { tinkatuff } from "./pokemon/tinkatuff";
import { tinkaton } from "./pokemon/tinkaton";
import { wiglett } from "./pokemon/wiglett";
import { wugtrio } from "./pokemon/wugtrio";
import { bombirdier } from "./pokemon/bombirdier";
import { finizen } from "./pokemon/finizen";
import { palafin_zero } from "./pokemon/palafin-zero";
import { varoom } from "./pokemon/varoom";
import { revavroom } from "./pokemon/revavroom";
import { cyclizar } from "./pokemon/cyclizar";
import { orthworm } from "./pokemon/orthworm";
import { glimmet } from "./pokemon/glimmet";
import { glimmora } from "./pokemon/glimmora";
import { greavard } from "./pokemon/greavard";
import { houndstone } from "./pokemon/houndstone";
import { flamigo } from "./pokemon/flamigo";
import { cetoddle } from "./pokemon/cetoddle";
import { cetitan } from "./pokemon/cetitan";
import { veluza } from "./pokemon/veluza";
import { dondozo } from "./pokemon/dondozo";
import { tatsugiri_curly } from "./pokemon/tatsugiri-curly";
import { annihilape } from "./pokemon/annihilape";
import { clodsire } from "./pokemon/clodsire";
import { farigiraf } from "./pokemon/farigiraf";
import { dudunsparce_two_segment } from "./pokemon/dudunsparce-two-segment";
import { kingambit } from "./pokemon/kingambit";
import { great_tusk } from "./pokemon/great-tusk";
import { scream_tail } from "./pokemon/scream-tail";
import { brute_bonnet } from "./pokemon/brute-bonnet";
import { flutter_mane } from "./pokemon/flutter-mane";
import { slither_wing } from "./pokemon/slither-wing";
import { sandy_shocks } from "./pokemon/sandy-shocks";
import { iron_treads } from "./pokemon/iron-treads";
import { iron_bundle } from "./pokemon/iron-bundle";
import { iron_hands } from "./pokemon/iron-hands";
import { iron_jugulis } from "./pokemon/iron-jugulis";
import { iron_moth } from "./pokemon/iron-moth";
import { iron_thorns } from "./pokemon/iron-thorns";
import { frigibax } from "./pokemon/frigibax";
import { arctibax } from "./pokemon/arctibax";
import { baxcalibur } from "./pokemon/baxcalibur";
import { gimmighoul } from "./pokemon/gimmighoul";
import { gholdengo } from "./pokemon/gholdengo";
import { wo_chien } from "./pokemon/wo-chien";
import { chien_pao } from "./pokemon/chien-pao";
import { ting_lu } from "./pokemon/ting-lu";
import { chi_yu } from "./pokemon/chi-yu";
import { roaring_moon } from "./pokemon/roaring-moon";
import { iron_valiant } from "./pokemon/iron-valiant";
import { koraidon } from "./pokemon/koraidon";
import { miraidon } from "./pokemon/miraidon";
import { walking_wake } from "./pokemon/walking-wake";
import { iron_leaves } from "./pokemon/iron-leaves";
import { dipplin } from "./pokemon/dipplin";
import { poltchageist } from "./pokemon/poltchageist";
import { sinistcha } from "./pokemon/sinistcha";
import { okidogi } from "./pokemon/okidogi";
import { munkidori } from "./pokemon/munkidori";
import { fezandipiti } from "./pokemon/fezandipiti";
import { ogerpon } from "./pokemon/ogerpon";
import { archaludon } from "./pokemon/archaludon";
import { hydrapple } from "./pokemon/hydrapple";
import { gouging_fire } from "./pokemon/gouging-fire";
import { raging_bolt } from "./pokemon/raging-bolt";
import { iron_boulder } from "./pokemon/iron-boulder";
import { iron_crown } from "./pokemon/iron-crown";
import { terapagos } from "./pokemon/terapagos";
import { pecharunt } from "./pokemon/pecharunt";
import { deoxys_attack } from "./pokemon/deoxys-attack";
import { deoxys_defense } from "./pokemon/deoxys-defense";
import { deoxys_speed } from "./pokemon/deoxys-speed";
import { wormadam_sandy } from "./pokemon/wormadam-sandy";
import { wormadam_trash } from "./pokemon/wormadam-trash";
import { shaymin_sky } from "./pokemon/shaymin-sky";
import { giratina_origin } from "./pokemon/giratina-origin";
import { rotom_heat } from "./pokemon/rotom-heat";
import { rotom_wash } from "./pokemon/rotom-wash";
import { rotom_frost } from "./pokemon/rotom-frost";
import { rotom_fan } from "./pokemon/rotom-fan";
import { rotom_mow } from "./pokemon/rotom-mow";
import { castform_sunny } from "./pokemon/castform-sunny";
import { castform_rainy } from "./pokemon/castform-rainy";
import { castform_snowy } from "./pokemon/castform-snowy";
import { basculin_blue_striped } from "./pokemon/basculin-blue-striped";
import { darmanitan_zen } from "./pokemon/darmanitan-zen";
import { meloetta_pirouette } from "./pokemon/meloetta-pirouette";
import { tornadus_therian } from "./pokemon/tornadus-therian";
import { thundurus_therian } from "./pokemon/thundurus-therian";
import { landorus_therian } from "./pokemon/landorus-therian";
import { kyurem_black } from "./pokemon/kyurem-black";
import { kyurem_white } from "./pokemon/kyurem-white";
import { keldeo_resolute } from "./pokemon/keldeo-resolute";
import { meowstic_female } from "./pokemon/meowstic-female";
import { aegislash_blade } from "./pokemon/aegislash-blade";
import { pumpkaboo_small } from "./pokemon/pumpkaboo-small";
import { pumpkaboo_large } from "./pokemon/pumpkaboo-large";
import { pumpkaboo_super } from "./pokemon/pumpkaboo-super";
import { gourgeist_small } from "./pokemon/gourgeist-small";
import { gourgeist_large } from "./pokemon/gourgeist-large";
import { gourgeist_super } from "./pokemon/gourgeist-super";
import { venusaur_mega } from "./pokemon/venusaur-mega";
import { charizard_mega_x } from "./pokemon/charizard-mega-x";
import { charizard_mega_y } from "./pokemon/charizard-mega-y";
import { blastoise_mega } from "./pokemon/blastoise-mega";
import { alakazam_mega } from "./pokemon/alakazam-mega";
import { gengar_mega } from "./pokemon/gengar-mega";
import { kangaskhan_mega } from "./pokemon/kangaskhan-mega";
import { pinsir_mega } from "./pokemon/pinsir-mega";
import { gyarados_mega } from "./pokemon/gyarados-mega";
import { aerodactyl_mega } from "./pokemon/aerodactyl-mega";
import { mewtwo_mega_x } from "./pokemon/mewtwo-mega-x";
import { mewtwo_mega_y } from "./pokemon/mewtwo-mega-y";
import { ampharos_mega } from "./pokemon/ampharos-mega";
import { scizor_mega } from "./pokemon/scizor-mega";
import { heracross_mega } from "./pokemon/heracross-mega";
import { houndoom_mega } from "./pokemon/houndoom-mega";
import { tyranitar_mega } from "./pokemon/tyranitar-mega";
import { blaziken_mega } from "./pokemon/blaziken-mega";
import { gardevoir_mega } from "./pokemon/gardevoir-mega";
import { mawile_mega } from "./pokemon/mawile-mega";
import { aggron_mega } from "./pokemon/aggron-mega";
import { medicham_mega } from "./pokemon/medicham-mega";
import { manectric_mega } from "./pokemon/manectric-mega";
import { banette_mega } from "./pokemon/banette-mega";
import { absol_mega } from "./pokemon/absol-mega";
import { garchomp_mega } from "./pokemon/garchomp-mega";
import { lucario_mega } from "./pokemon/lucario-mega";
import { abomasnow_mega } from "./pokemon/abomasnow-mega";
import { floette_eternal } from "./pokemon/floette-eternal";
import { latias_mega } from "./pokemon/latias-mega";
import { latios_mega } from "./pokemon/latios-mega";
import { swampert_mega } from "./pokemon/swampert-mega";
import { sceptile_mega } from "./pokemon/sceptile-mega";
import { sableye_mega } from "./pokemon/sableye-mega";
import { altaria_mega } from "./pokemon/altaria-mega";
import { gallade_mega } from "./pokemon/gallade-mega";
import { audino_mega } from "./pokemon/audino-mega";
import { sharpedo_mega } from "./pokemon/sharpedo-mega";
import { slowbro_mega } from "./pokemon/slowbro-mega";
import { steelix_mega } from "./pokemon/steelix-mega";
import { pidgeot_mega } from "./pokemon/pidgeot-mega";
import { glalie_mega } from "./pokemon/glalie-mega";
import { diancie_mega } from "./pokemon/diancie-mega";
import { metagross_mega } from "./pokemon/metagross-mega";
import { kyogre_primal } from "./pokemon/kyogre-primal";
import { groudon_primal } from "./pokemon/groudon-primal";
import { rayquaza_mega } from "./pokemon/rayquaza-mega";
import { pikachu_rock_star } from "./pokemon/pikachu-rock-star";
import { pikachu_belle } from "./pokemon/pikachu-belle";
import { pikachu_pop_star } from "./pokemon/pikachu-pop-star";
import { pikachu_phd } from "./pokemon/pikachu-phd";
import { pikachu_libre } from "./pokemon/pikachu-libre";
import { pikachu_cosplay } from "./pokemon/pikachu-cosplay";
import { hoopa_unbound } from "./pokemon/hoopa-unbound";
import { camerupt_mega } from "./pokemon/camerupt-mega";
import { lopunny_mega } from "./pokemon/lopunny-mega";
import { salamence_mega } from "./pokemon/salamence-mega";
import { beedrill_mega } from "./pokemon/beedrill-mega";
import { rattata_alola } from "./pokemon/rattata-alola";
import { raticate_alola } from "./pokemon/raticate-alola";
import { raticate_totem_alola } from "./pokemon/raticate-totem-alola";
import { pikachu_original_cap } from "./pokemon/pikachu-original-cap";
import { pikachu_hoenn_cap } from "./pokemon/pikachu-hoenn-cap";
import { pikachu_sinnoh_cap } from "./pokemon/pikachu-sinnoh-cap";
import { pikachu_unova_cap } from "./pokemon/pikachu-unova-cap";
import { pikachu_kalos_cap } from "./pokemon/pikachu-kalos-cap";
import { pikachu_alola_cap } from "./pokemon/pikachu-alola-cap";
import { raichu_alola } from "./pokemon/raichu-alola";
import { sandshrew_alola } from "./pokemon/sandshrew-alola";
import { sandslash_alola } from "./pokemon/sandslash-alola";
import { vulpix_alola } from "./pokemon/vulpix-alola";
import { ninetales_alola } from "./pokemon/ninetales-alola";
import { diglett_alola } from "./pokemon/diglett-alola";
import { dugtrio_alola } from "./pokemon/dugtrio-alola";
import { meowth_alola } from "./pokemon/meowth-alola";
import { persian_alola } from "./pokemon/persian-alola";
import { geodude_alola } from "./pokemon/geodude-alola";
import { graveler_alola } from "./pokemon/graveler-alola";
import { golem_alola } from "./pokemon/golem-alola";
import { grimer_alola } from "./pokemon/grimer-alola";
import { muk_alola } from "./pokemon/muk-alola";
import { exeggutor_alola } from "./pokemon/exeggutor-alola";
import { marowak_alola } from "./pokemon/marowak-alola";
import { greninja_battle_bond } from "./pokemon/greninja-battle-bond";
import { greninja_ash } from "./pokemon/greninja-ash";
import { zygarde_10_power_construct } from "./pokemon/zygarde-10-power-construct";
import { zygarde_50_power_construct } from "./pokemon/zygarde-50-power-construct";
import { zygarde_complete } from "./pokemon/zygarde-complete";
import { gumshoos_totem } from "./pokemon/gumshoos-totem";
import { vikavolt_totem } from "./pokemon/vikavolt-totem";
import { oricorio_pom_pom } from "./pokemon/oricorio-pom-pom";
import { oricorio_pau } from "./pokemon/oricorio-pau";
import { oricorio_sensu } from "./pokemon/oricorio-sensu";
import { lycanroc_midnight } from "./pokemon/lycanroc-midnight";
import { wishiwashi_school } from "./pokemon/wishiwashi-school";
import { lurantis_totem } from "./pokemon/lurantis-totem";
import { salazzle_totem } from "./pokemon/salazzle-totem";
import { minior_orange_meteor } from "./pokemon/minior-orange-meteor";
import { minior_yellow_meteor } from "./pokemon/minior-yellow-meteor";
import { minior_green_meteor } from "./pokemon/minior-green-meteor";
import { minior_blue_meteor } from "./pokemon/minior-blue-meteor";
import { minior_indigo_meteor } from "./pokemon/minior-indigo-meteor";
import { minior_violet_meteor } from "./pokemon/minior-violet-meteor";
import { minior_red } from "./pokemon/minior-red";
import { minior_orange } from "./pokemon/minior-orange";
import { minior_yellow } from "./pokemon/minior-yellow";
import { minior_green } from "./pokemon/minior-green";
import { minior_blue } from "./pokemon/minior-blue";
import { minior_indigo } from "./pokemon/minior-indigo";
import { minior_violet } from "./pokemon/minior-violet";
import { mimikyu_busted } from "./pokemon/mimikyu-busted";
import { mimikyu_totem_disguised } from "./pokemon/mimikyu-totem-disguised";
import { mimikyu_totem_busted } from "./pokemon/mimikyu-totem-busted";
import { kommo_o_totem } from "./pokemon/kommo-o-totem";
import { magearna_original } from "./pokemon/magearna-original";
import { pikachu_partner_cap } from "./pokemon/pikachu-partner-cap";
import { marowak_totem } from "./pokemon/marowak-totem";
import { ribombee_totem } from "./pokemon/ribombee-totem";
import { rockruff_own_tempo } from "./pokemon/rockruff-own-tempo";
import { lycanroc_dusk } from "./pokemon/lycanroc-dusk";
import { araquanid_totem } from "./pokemon/araquanid-totem";
import { togedemaru_totem } from "./pokemon/togedemaru-totem";
import { necrozma_dusk } from "./pokemon/necrozma-dusk";
import { necrozma_dawn } from "./pokemon/necrozma-dawn";
import { necrozma_ultra } from "./pokemon/necrozma-ultra";
import { pikachu_starter } from "./pokemon/pikachu-starter";
import { eevee_starter } from "./pokemon/eevee-starter";
import { pikachu_world_cap } from "./pokemon/pikachu-world-cap";
import { meowth_galar } from "./pokemon/meowth-galar";
import { ponyta_galar } from "./pokemon/ponyta-galar";
import { rapidash_galar } from "./pokemon/rapidash-galar";
import { slowpoke_galar } from "./pokemon/slowpoke-galar";
import { slowbro_galar } from "./pokemon/slowbro-galar";
import { farfetchd_galar } from "./pokemon/farfetchd-galar";
import { weezing_galar } from "./pokemon/weezing-galar";
import { mr_mime_galar } from "./pokemon/mr-mime-galar";
import { articuno_galar } from "./pokemon/articuno-galar";
import { zapdos_galar } from "./pokemon/zapdos-galar";
import { moltres_galar } from "./pokemon/moltres-galar";
import { slowking_galar } from "./pokemon/slowking-galar";
import { corsola_galar } from "./pokemon/corsola-galar";
import { zigzagoon_galar } from "./pokemon/zigzagoon-galar";
import { linoone_galar } from "./pokemon/linoone-galar";
import { darumaka_galar } from "./pokemon/darumaka-galar";
import { darmanitan_galar_standard } from "./pokemon/darmanitan-galar-standard";
import { darmanitan_galar_zen } from "./pokemon/darmanitan-galar-zen";
import { yamask_galar } from "./pokemon/yamask-galar";
import { stunfisk_galar } from "./pokemon/stunfisk-galar";
import { zygarde_10 } from "./pokemon/zygarde-10";
import { cramorant_gulping } from "./pokemon/cramorant-gulping";
import { cramorant_gorging } from "./pokemon/cramorant-gorging";
import { toxtricity_low_key } from "./pokemon/toxtricity-low-key";
import { eiscue_noice } from "./pokemon/eiscue-noice";
import { indeedee_female } from "./pokemon/indeedee-female";
import { morpeko_hangry } from "./pokemon/morpeko-hangry";
import { zacian_crowned } from "./pokemon/zacian-crowned";
import { zamazenta_crowned } from "./pokemon/zamazenta-crowned";
import { eternatus_eternamax } from "./pokemon/eternatus-eternamax";
import { urshifu_rapid_strike } from "./pokemon/urshifu-rapid-strike";
import { zarude_dada } from "./pokemon/zarude-dada";
import { calyrex_ice } from "./pokemon/calyrex-ice";
import { calyrex_shadow } from "./pokemon/calyrex-shadow";
import { venusaur_gmax } from "./pokemon/venusaur-gmax";
import { charizard_gmax } from "./pokemon/charizard-gmax";
import { blastoise_gmax } from "./pokemon/blastoise-gmax";
import { butterfree_gmax } from "./pokemon/butterfree-gmax";
import { pikachu_gmax } from "./pokemon/pikachu-gmax";
import { meowth_gmax } from "./pokemon/meowth-gmax";
import { machamp_gmax } from "./pokemon/machamp-gmax";
import { gengar_gmax } from "./pokemon/gengar-gmax";
import { kingler_gmax } from "./pokemon/kingler-gmax";
import { lapras_gmax } from "./pokemon/lapras-gmax";
import { eevee_gmax } from "./pokemon/eevee-gmax";
import { snorlax_gmax } from "./pokemon/snorlax-gmax";
import { garbodor_gmax } from "./pokemon/garbodor-gmax";
import { melmetal_gmax } from "./pokemon/melmetal-gmax";
import { rillaboom_gmax } from "./pokemon/rillaboom-gmax";
import { cinderace_gmax } from "./pokemon/cinderace-gmax";
import { inteleon_gmax } from "./pokemon/inteleon-gmax";
import { corviknight_gmax } from "./pokemon/corviknight-gmax";
import { orbeetle_gmax } from "./pokemon/orbeetle-gmax";
import { drednaw_gmax } from "./pokemon/drednaw-gmax";
import { coalossal_gmax } from "./pokemon/coalossal-gmax";
import { flapple_gmax } from "./pokemon/flapple-gmax";
import { appletun_gmax } from "./pokemon/appletun-gmax";
import { sandaconda_gmax } from "./pokemon/sandaconda-gmax";
import { toxtricity_amped_gmax } from "./pokemon/toxtricity-amped-gmax";
import { centiskorch_gmax } from "./pokemon/centiskorch-gmax";
import { hatterene_gmax } from "./pokemon/hatterene-gmax";
import { grimmsnarl_gmax } from "./pokemon/grimmsnarl-gmax";
import { alcremie_gmax } from "./pokemon/alcremie-gmax";
import { copperajah_gmax } from "./pokemon/copperajah-gmax";
import { duraludon_gmax } from "./pokemon/duraludon-gmax";
import { urshifu_single_strike_gmax } from "./pokemon/urshifu-single-strike-gmax";
import { urshifu_rapid_strike_gmax } from "./pokemon/urshifu-rapid-strike-gmax";
import { toxtricity_low_key_gmax } from "./pokemon/toxtricity-low-key-gmax";
import { growlithe_hisui } from "./pokemon/growlithe-hisui";
import { arcanine_hisui } from "./pokemon/arcanine-hisui";
import { voltorb_hisui } from "./pokemon/voltorb-hisui";
import { electrode_hisui } from "./pokemon/electrode-hisui";
import { typhlosion_hisui } from "./pokemon/typhlosion-hisui";
import { qwilfish_hisui } from "./pokemon/qwilfish-hisui";
import { sneasel_hisui } from "./pokemon/sneasel-hisui";
import { samurott_hisui } from "./pokemon/samurott-hisui";
import { lilligant_hisui } from "./pokemon/lilligant-hisui";
import { zorua_hisui } from "./pokemon/zorua-hisui";
import { zoroark_hisui } from "./pokemon/zoroark-hisui";
import { braviary_hisui } from "./pokemon/braviary-hisui";
import { sliggoo_hisui } from "./pokemon/sliggoo-hisui";
import { goodra_hisui } from "./pokemon/goodra-hisui";
import { avalugg_hisui } from "./pokemon/avalugg-hisui";
import { decidueye_hisui } from "./pokemon/decidueye-hisui";
import { dialga_origin } from "./pokemon/dialga-origin";
import { palkia_origin } from "./pokemon/palkia-origin";
import { basculin_white_striped } from "./pokemon/basculin-white-striped";
import { basculegion_female } from "./pokemon/basculegion-female";
import { enamorus_therian } from "./pokemon/enamorus-therian";
import { tauros_paldea_combat_breed } from "./pokemon/tauros-paldea-combat-breed";
import { tauros_paldea_blaze_breed } from "./pokemon/tauros-paldea-blaze-breed";
import { tauros_paldea_aqua_breed } from "./pokemon/tauros-paldea-aqua-breed";
import { wooper_paldea } from "./pokemon/wooper-paldea";
import { oinkologne_female } from "./pokemon/oinkologne-female";
import { dudunsparce_three_segment } from "./pokemon/dudunsparce-three-segment";
import { palafin_hero } from "./pokemon/palafin-hero";
import { maushold_family_of_three } from "./pokemon/maushold-family-of-three";
import { tatsugiri_droopy } from "./pokemon/tatsugiri-droopy";
import { tatsugiri_stretchy } from "./pokemon/tatsugiri-stretchy";
import { squawkabilly_blue_plumage } from "./pokemon/squawkabilly-blue-plumage";
import { squawkabilly_yellow_plumage } from "./pokemon/squawkabilly-yellow-plumage";
import { squawkabilly_white_plumage } from "./pokemon/squawkabilly-white-plumage";
import { gimmighoul_roaming } from "./pokemon/gimmighoul-roaming";
import { koraidon_limited_build } from "./pokemon/koraidon-limited-build";
import { koraidon_sprinting_build } from "./pokemon/koraidon-sprinting-build";
import { koraidon_swimming_build } from "./pokemon/koraidon-swimming-build";
import { koraidon_gliding_build } from "./pokemon/koraidon-gliding-build";
import { miraidon_low_power_mode } from "./pokemon/miraidon-low-power-mode";
import { miraidon_drive_mode } from "./pokemon/miraidon-drive-mode";
import { miraidon_aquatic_mode } from "./pokemon/miraidon-aquatic-mode";
import { miraidon_glide_mode } from "./pokemon/miraidon-glide-mode";
import { ursaluna_bloodmoon } from "./pokemon/ursaluna-bloodmoon";
import { ogerpon_wellspring_mask } from "./pokemon/ogerpon-wellspring-mask";
import { ogerpon_hearthflame_mask } from "./pokemon/ogerpon-hearthflame-mask";
import { ogerpon_cornerstone_mask } from "./pokemon/ogerpon-cornerstone-mask";
import { terapagos_terastal } from "./pokemon/terapagos-terastal";
import { terapagos_stellar } from "./pokemon/terapagos-stellar";
import { clefable_mega } from "./pokemon/clefable-mega";
import { victreebel_mega } from "./pokemon/victreebel-mega";
import { starmie_mega } from "./pokemon/starmie-mega";
import { dragonite_mega } from "./pokemon/dragonite-mega";
import { meganium_mega } from "./pokemon/meganium-mega";
import { feraligatr_mega } from "./pokemon/feraligatr-mega";
import { skarmory_mega } from "./pokemon/skarmory-mega";
import { froslass_mega } from "./pokemon/froslass-mega";
import { emboar_mega } from "./pokemon/emboar-mega";
import { excadrill_mega } from "./pokemon/excadrill-mega";
import { scolipede_mega } from "./pokemon/scolipede-mega";
import { scrafty_mega } from "./pokemon/scrafty-mega";
import { eelektross_mega } from "./pokemon/eelektross-mega";
import { chandelure_mega } from "./pokemon/chandelure-mega";
import { chesnaught_mega } from "./pokemon/chesnaught-mega";
import { delphox_mega } from "./pokemon/delphox-mega";
import { greninja_mega } from "./pokemon/greninja-mega";
import { pyroar_mega } from "./pokemon/pyroar-mega";
import { floette_mega } from "./pokemon/floette-mega";
import { malamar_mega } from "./pokemon/malamar-mega";
import { barbaracle_mega } from "./pokemon/barbaracle-mega";
import { dragalge_mega } from "./pokemon/dragalge-mega";
import { hawlucha_mega } from "./pokemon/hawlucha-mega";
import { zygarde_mega } from "./pokemon/zygarde-mega";
import { drampa_mega } from "./pokemon/drampa-mega";
import { falinks_mega } from "./pokemon/falinks-mega";
import { raichu_mega_x } from "./pokemon/raichu-mega-x";
import { raichu_mega_y } from "./pokemon/raichu-mega-y";
import { chimecho_mega } from "./pokemon/chimecho-mega";
import { absol_mega_z } from "./pokemon/absol-mega-z";
import { staraptor_mega } from "./pokemon/staraptor-mega";
import { garchomp_mega_z } from "./pokemon/garchomp-mega-z";
import { lucario_mega_z } from "./pokemon/lucario-mega-z";
import { heatran_mega } from "./pokemon/heatran-mega";
import { darkrai_mega } from "./pokemon/darkrai-mega";
import { golurk_mega } from "./pokemon/golurk-mega";
import { meowstic_mega } from "./pokemon/meowstic-mega";
import { crabominable_mega } from "./pokemon/crabominable-mega";
import { golisopod_mega } from "./pokemon/golisopod-mega";
import { magearna_mega } from "./pokemon/magearna-mega";
import { magearna_original_mega } from "./pokemon/magearna-original-mega";
import { zeraora_mega } from "./pokemon/zeraora-mega";
import { scovillain_mega } from "./pokemon/scovillain-mega";
import { glimmora_mega } from "./pokemon/glimmora-mega";
import { tatsugiri_curly_mega } from "./pokemon/tatsugiri-curly-mega";
import { tatsugiri_droopy_mega } from "./pokemon/tatsugiri-droopy-mega";
import { tatsugiri_stretchy_mega } from "./pokemon/tatsugiri-stretchy-mega";
import { baxcalibur_mega } from "./pokemon/baxcalibur-mega";
import { toxtricity } from "./pokemon/toxtricity";

export const POKE_DATA: Record<PokeNames, PokeData> = {
  [PokeNames.BULBASAUR]: bulbasaur,
  [PokeNames.IVYSAUR]: ivysaur,
  [PokeNames.VENUSAUR]: venusaur,
  [PokeNames.CHARMANDER]: charmander,
  [PokeNames.CHARMELEON]: charmeleon,
  [PokeNames.CHARIZARD]: charizard,
  [PokeNames.SQUIRTLE]: squirtle,
  [PokeNames.WARTORTLE]: wartortle,
  [PokeNames.BLASTOISE]: blastoise,
  [PokeNames.CATERPIE]: caterpie,
  [PokeNames.METAPOD]: metapod,
  [PokeNames.BUTTERFREE]: butterfree,
  [PokeNames.WEEDLE]: weedle,
  [PokeNames.KAKUNA]: kakuna,
  [PokeNames.BEEDRILL]: beedrill,
  [PokeNames.PIDGEY]: pidgey,
  [PokeNames.PIDGEOTTO]: pidgeotto,
  [PokeNames.PIDGEOT]: pidgeot,
  [PokeNames.RATTATA]: rattata,
  [PokeNames.RATICATE]: raticate,
  [PokeNames.SPEAROW]: spearow,
  [PokeNames.FEAROW]: fearow,
  [PokeNames.EKANS]: ekans,
  [PokeNames.ARBOK]: arbok,
  [PokeNames.PIKACHU]: pikachu,
  [PokeNames.RAICHU]: raichu,
  [PokeNames.SANDSHREW]: sandshrew,
  [PokeNames.SANDSLASH]: sandslash,
  [PokeNames.NIDORAN_F]: nidoran_f,
  [PokeNames.NIDORINA]: nidorina,
  [PokeNames.NIDOQUEEN]: nidoqueen,
  [PokeNames.NIDORAN_M]: nidoran_m,
  [PokeNames.NIDORINO]: nidorino,
  [PokeNames.NIDOKING]: nidoking,
  [PokeNames.CLEFAIRY]: clefairy,
  [PokeNames.CLEFABLE]: clefable,
  [PokeNames.VULPIX]: vulpix,
  [PokeNames.NINETALES]: ninetales,
  [PokeNames.JIGGLYPUFF]: jigglypuff,
  [PokeNames.WIGGLYTUFF]: wigglytuff,
  [PokeNames.ZUBAT]: zubat,
  [PokeNames.GOLBAT]: golbat,
  [PokeNames.ODDISH]: oddish,
  [PokeNames.GLOOM]: gloom,
  [PokeNames.VILEPLUME]: vileplume,
  [PokeNames.PARAS]: paras,
  [PokeNames.PARASECT]: parasect,
  [PokeNames.VENONAT]: venonat,
  [PokeNames.VENOMOTH]: venomoth,
  [PokeNames.DIGLETT]: diglett,
  [PokeNames.DUGTRIO]: dugtrio,
  [PokeNames.MEOWTH]: meowth,
  [PokeNames.PERSIAN]: persian,
  [PokeNames.PSYDUCK]: psyduck,
  [PokeNames.GOLDUCK]: golduck,
  [PokeNames.MANKEY]: mankey,
  [PokeNames.PRIMEAPE]: primeape,
  [PokeNames.GROWLITHE]: growlithe,
  [PokeNames.ARCANINE]: arcanine,
  [PokeNames.POLIWAG]: poliwag,
  [PokeNames.POLIWHIRL]: poliwhirl,
  [PokeNames.POLIWRATH]: poliwrath,
  [PokeNames.ABRA]: abra,
  [PokeNames.KADABRA]: kadabra,
  [PokeNames.ALAKAZAM]: alakazam,
  [PokeNames.MACHOP]: machop,
  [PokeNames.MACHOKE]: machoke,
  [PokeNames.MACHAMP]: machamp,
  [PokeNames.BELLSPROUT]: bellsprout,
  [PokeNames.WEEPINBELL]: weepinbell,
  [PokeNames.VICTREEBEL]: victreebel,
  [PokeNames.TENTACOOL]: tentacool,
  [PokeNames.TENTACRUEL]: tentacruel,
  [PokeNames.GEODUDE]: geodude,
  [PokeNames.GRAVELER]: graveler,
  [PokeNames.GOLEM]: golem,
  [PokeNames.PONYTA]: ponyta,
  [PokeNames.RAPIDASH]: rapidash,
  [PokeNames.SLOWPOKE]: slowpoke,
  [PokeNames.SLOWBRO]: slowbro,
  [PokeNames.MAGNEMITE]: magnemite,
  [PokeNames.MAGNETON]: magneton,
  [PokeNames.FARFETCHD]: farfetchd,
  [PokeNames.DODUO]: doduo,
  [PokeNames.DODRIO]: dodrio,
  [PokeNames.SEEL]: seel,
  [PokeNames.DEWGONG]: dewgong,
  [PokeNames.GRIMER]: grimer,
  [PokeNames.MUK]: muk,
  [PokeNames.SHELLDER]: shellder,
  [PokeNames.CLOYSTER]: cloyster,
  [PokeNames.GASTLY]: gastly,
  [PokeNames.HAUNTER]: haunter,
  [PokeNames.GENGAR]: gengar,
  [PokeNames.ONIX]: onix,
  [PokeNames.DROWZEE]: drowzee,
  [PokeNames.HYPNO]: hypno,
  [PokeNames.KRABBY]: krabby,
  [PokeNames.KINGLER]: kingler,
  [PokeNames.VOLTORB]: voltorb,
  [PokeNames.ELECTRODE]: electrode,
  [PokeNames.EXEGGCUTE]: exeggcute,
  [PokeNames.EXEGGUTOR]: exeggutor,
  [PokeNames.CUBONE]: cubone,
  [PokeNames.MAROWAK]: marowak,
  [PokeNames.HITMONLEE]: hitmonlee,
  [PokeNames.HITMONCHAN]: hitmonchan,
  [PokeNames.LICKITUNG]: lickitung,
  [PokeNames.KOFFING]: koffing,
  [PokeNames.WEEZING]: weezing,
  [PokeNames.RHYHORN]: rhyhorn,
  [PokeNames.RHYDON]: rhydon,
  [PokeNames.CHANSEY]: chansey,
  [PokeNames.TANGELA]: tangela,
  [PokeNames.KANGASKHAN]: kangaskhan,
  [PokeNames.HORSEA]: horsea,
  [PokeNames.SEADRA]: seadra,
  [PokeNames.GOLDEEN]: goldeen,
  [PokeNames.SEAKING]: seaking,
  [PokeNames.STARYU]: staryu,
  [PokeNames.STARMIE]: starmie,
  [PokeNames.MR_MIME]: mr_mime,
  [PokeNames.SCYTHER]: scyther,
  [PokeNames.JYNX]: jynx,
  [PokeNames.ELECTABUZZ]: electabuzz,
  [PokeNames.MAGMAR]: magmar,
  [PokeNames.PINSIR]: pinsir,
  [PokeNames.TAUROS]: tauros,
  [PokeNames.MAGIKARP]: magikarp,
  [PokeNames.GYARADOS]: gyarados,
  [PokeNames.LAPRAS]: lapras,
  [PokeNames.DITTO]: ditto,
  [PokeNames.EEVEE]: eevee,
  [PokeNames.VAPOREON]: vaporeon,
  [PokeNames.JOLTEON]: jolteon,
  [PokeNames.FLAREON]: flareon,
  [PokeNames.PORYGON]: porygon,
  [PokeNames.OMANYTE]: omanyte,
  [PokeNames.OMASTAR]: omastar,
  [PokeNames.KABUTO]: kabuto,
  [PokeNames.KABUTOPS]: kabutops,
  [PokeNames.AERODACTYL]: aerodactyl,
  [PokeNames.SNORLAX]: snorlax,
  [PokeNames.ARTICUNO]: articuno,
  [PokeNames.ZAPDOS]: zapdos,
  [PokeNames.MOLTRES]: moltres,
  [PokeNames.DRATINI]: dratini,
  [PokeNames.DRAGONAIR]: dragonair,
  [PokeNames.DRAGONITE]: dragonite,
  [PokeNames.MEWTWO]: mewtwo,
  [PokeNames.MEW]: mew,
  [PokeNames.CHIKORITA]: chikorita,
  [PokeNames.BAYLEEF]: bayleef,
  [PokeNames.MEGANIUM]: meganium,
  [PokeNames.CYNDAQUIL]: cyndaquil,
  [PokeNames.QUILAVA]: quilava,
  [PokeNames.TYPHLOSION]: typhlosion,
  [PokeNames.TOTODILE]: totodile,
  [PokeNames.CROCONAW]: croconaw,
  [PokeNames.FERALIGATR]: feraligatr,
  [PokeNames.SENTRET]: sentret,
  [PokeNames.FURRET]: furret,
  [PokeNames.HOOTHOOT]: hoothoot,
  [PokeNames.NOCTOWL]: noctowl,
  [PokeNames.LEDYBA]: ledyba,
  [PokeNames.LEDIAN]: ledian,
  [PokeNames.SPINARAK]: spinarak,
  [PokeNames.ARIADOS]: ariados,
  [PokeNames.CROBAT]: crobat,
  [PokeNames.CHINCHOU]: chinchou,
  [PokeNames.LANTURN]: lanturn,
  [PokeNames.PICHU]: pichu,
  [PokeNames.CLEFFA]: cleffa,
  [PokeNames.IGGLYBUFF]: igglybuff,
  [PokeNames.TOGEPI]: togepi,
  [PokeNames.TOGETIC]: togetic,
  [PokeNames.NATU]: natu,
  [PokeNames.XATU]: xatu,
  [PokeNames.MAREEP]: mareep,
  [PokeNames.FLAAFFY]: flaaffy,
  [PokeNames.AMPHAROS]: ampharos,
  [PokeNames.BELLOSSOM]: bellossom,
  [PokeNames.MARILL]: marill,
  [PokeNames.AZUMARILL]: azumarill,
  [PokeNames.SUDOWOODO]: sudowoodo,
  [PokeNames.POLITOED]: politoed,
  [PokeNames.HOPPIP]: hoppip,
  [PokeNames.SKIPLOOM]: skiploom,
  [PokeNames.JUMPLUFF]: jumpluff,
  [PokeNames.AIPOM]: aipom,
  [PokeNames.SUNKERN]: sunkern,
  [PokeNames.SUNFLORA]: sunflora,
  [PokeNames.YANMA]: yanma,
  [PokeNames.WOOPER]: wooper,
  [PokeNames.QUAGSIRE]: quagsire,
  [PokeNames.ESPEON]: espeon,
  [PokeNames.UMBREON]: umbreon,
  [PokeNames.MURKROW]: murkrow,
  [PokeNames.SLOWKING]: slowking,
  [PokeNames.MISDREAVUS]: misdreavus,
  [PokeNames.UNOWN]: unown,
  [PokeNames.WOBBUFFET]: wobbuffet,
  [PokeNames.GIRAFARIG]: girafarig,
  [PokeNames.PINECO]: pineco,
  [PokeNames.FORRETRESS]: forretress,
  [PokeNames.DUNSPARCE]: dunsparce,
  [PokeNames.GLIGAR]: gligar,
  [PokeNames.STEELIX]: steelix,
  [PokeNames.SNUBBULL]: snubbull,
  [PokeNames.GRANBULL]: granbull,
  [PokeNames.QWILFISH]: qwilfish,
  [PokeNames.SCIZOR]: scizor,
  [PokeNames.SHUCKLE]: shuckle,
  [PokeNames.HERACROSS]: heracross,
  [PokeNames.SNEASEL]: sneasel,
  [PokeNames.TEDDIURSA]: teddiursa,
  [PokeNames.URSARING]: ursaring,
  [PokeNames.SLUGMA]: slugma,
  [PokeNames.MAGCARGO]: magcargo,
  [PokeNames.SWINUB]: swinub,
  [PokeNames.PILOSWINE]: piloswine,
  [PokeNames.CORSOLA]: corsola,
  [PokeNames.REMORAID]: remoraid,
  [PokeNames.OCTILLERY]: octillery,
  [PokeNames.DELIBIRD]: delibird,
  [PokeNames.MANTINE]: mantine,
  [PokeNames.SKARMORY]: skarmory,
  [PokeNames.HOUNDOUR]: houndour,
  [PokeNames.HOUNDOOM]: houndoom,
  [PokeNames.KINGDRA]: kingdra,
  [PokeNames.PHANPY]: phanpy,
  [PokeNames.DONPHAN]: donphan,
  [PokeNames.PORYGON2]: porygon2,
  [PokeNames.STANTLER]: stantler,
  [PokeNames.SMEARGLE]: smeargle,
  [PokeNames.TYROGUE]: tyrogue,
  [PokeNames.HITMONTOP]: hitmontop,
  [PokeNames.SMOOCHUM]: smoochum,
  [PokeNames.ELEKID]: elekid,
  [PokeNames.MAGBY]: magby,
  [PokeNames.MILTANK]: miltank,
  [PokeNames.BLISSEY]: blissey,
  [PokeNames.RAIKOU]: raikou,
  [PokeNames.ENTEI]: entei,
  [PokeNames.SUICUNE]: suicune,
  [PokeNames.LARVITAR]: larvitar,
  [PokeNames.PUPITAR]: pupitar,
  [PokeNames.TYRANITAR]: tyranitar,
  [PokeNames.LUGIA]: lugia,
  [PokeNames.HO_OH]: ho_oh,
  [PokeNames.CELEBI]: celebi,
  [PokeNames.TREECKO]: treecko,
  [PokeNames.GROVYLE]: grovyle,
  [PokeNames.SCEPTILE]: sceptile,
  [PokeNames.TORCHIC]: torchic,
  [PokeNames.COMBUSKEN]: combusken,
  [PokeNames.BLAZIKEN]: blaziken,
  [PokeNames.MUDKIP]: mudkip,
  [PokeNames.MARSHTOMP]: marshtomp,
  [PokeNames.SWAMPERT]: swampert,
  [PokeNames.POOCHYENA]: poochyena,
  [PokeNames.MIGHTYENA]: mightyena,
  [PokeNames.ZIGZAGOON]: zigzagoon,
  [PokeNames.LINOONE]: linoone,
  [PokeNames.WURMPLE]: wurmple,
  [PokeNames.SILCOON]: silcoon,
  [PokeNames.BEAUTIFLY]: beautifly,
  [PokeNames.CASCOON]: cascoon,
  [PokeNames.DUSTOX]: dustox,
  [PokeNames.LOTAD]: lotad,
  [PokeNames.LOMBRE]: lombre,
  [PokeNames.LUDICOLO]: ludicolo,
  [PokeNames.SEEDOT]: seedot,
  [PokeNames.NUZLEAF]: nuzleaf,
  [PokeNames.SHIFTRY]: shiftry,
  [PokeNames.TAILLOW]: taillow,
  [PokeNames.SWELLOW]: swellow,
  [PokeNames.WINGULL]: wingull,
  [PokeNames.PELIPPER]: pelipper,
  [PokeNames.RALTS]: ralts,
  [PokeNames.KIRLIA]: kirlia,
  [PokeNames.GARDEVOIR]: gardevoir,
  [PokeNames.SURSKIT]: surskit,
  [PokeNames.MASQUERAIN]: masquerain,
  [PokeNames.SHROOMISH]: shroomish,
  [PokeNames.BRELOOM]: breloom,
  [PokeNames.SLAKOTH]: slakoth,
  [PokeNames.VIGOROTH]: vigoroth,
  [PokeNames.SLAKING]: slaking,
  [PokeNames.NINCADA]: nincada,
  [PokeNames.NINJASK]: ninjask,
  [PokeNames.SHEDINJA]: shedinja,
  [PokeNames.WHISMUR]: whismur,
  [PokeNames.LOUDRED]: loudred,
  [PokeNames.EXPLOUD]: exploud,
  [PokeNames.MAKUHITA]: makuhita,
  [PokeNames.HARIYAMA]: hariyama,
  [PokeNames.AZURILL]: azurill,
  [PokeNames.NOSEPASS]: nosepass,
  [PokeNames.SKITTY]: skitty,
  [PokeNames.DELCATTY]: delcatty,
  [PokeNames.SABLEYE]: sableye,
  [PokeNames.MAWILE]: mawile,
  [PokeNames.ARON]: aron,
  [PokeNames.LAIRON]: lairon,
  [PokeNames.AGGRON]: aggron,
  [PokeNames.MEDITITE]: meditite,
  [PokeNames.MEDICHAM]: medicham,
  [PokeNames.ELECTRIKE]: electrike,
  [PokeNames.MANECTRIC]: manectric,
  [PokeNames.PLUSLE]: plusle,
  [PokeNames.MINUN]: minun,
  [PokeNames.VOLBEAT]: volbeat,
  [PokeNames.ILLUMISE]: illumise,
  [PokeNames.ROSELIA]: roselia,
  [PokeNames.GULPIN]: gulpin,
  [PokeNames.SWALOT]: swalot,
  [PokeNames.CARVANHA]: carvanha,
  [PokeNames.SHARPEDO]: sharpedo,
  [PokeNames.WAILMER]: wailmer,
  [PokeNames.WAILORD]: wailord,
  [PokeNames.NUMEL]: numel,
  [PokeNames.CAMERUPT]: camerupt,
  [PokeNames.TORKOAL]: torkoal,
  [PokeNames.SPOINK]: spoink,
  [PokeNames.GRUMPIG]: grumpig,
  [PokeNames.SPINDA]: spinda,
  [PokeNames.TRAPINCH]: trapinch,
  [PokeNames.VIBRAVA]: vibrava,
  [PokeNames.FLYGON]: flygon,
  [PokeNames.CACNEA]: cacnea,
  [PokeNames.CACTURNE]: cacturne,
  [PokeNames.SWABLU]: swablu,
  [PokeNames.ALTARIA]: altaria,
  [PokeNames.ZANGOOSE]: zangoose,
  [PokeNames.SEVIPER]: seviper,
  [PokeNames.LUNATONE]: lunatone,
  [PokeNames.SOLROCK]: solrock,
  [PokeNames.BARBOACH]: barboach,
  [PokeNames.WHISCASH]: whiscash,
  [PokeNames.CORPHISH]: corphish,
  [PokeNames.CRAWDAUNT]: crawdaunt,
  [PokeNames.BALTOY]: baltoy,
  [PokeNames.CLAYDOL]: claydol,
  [PokeNames.LILEEP]: lileep,
  [PokeNames.CRADILY]: cradily,
  [PokeNames.ANORITH]: anorith,
  [PokeNames.ARMALDO]: armaldo,
  [PokeNames.FEEBAS]: feebas,
  [PokeNames.MILOTIC]: milotic,
  [PokeNames.CASTFORM]: castform,
  [PokeNames.KECLEON]: kecleon,
  [PokeNames.SHUPPET]: shuppet,
  [PokeNames.BANETTE]: banette,
  [PokeNames.DUSKULL]: duskull,
  [PokeNames.DUSCLOPS]: dusclops,
  [PokeNames.TROPIUS]: tropius,
  [PokeNames.CHIMECHO]: chimecho,
  [PokeNames.ABSOL]: absol,
  [PokeNames.WYNAUT]: wynaut,
  [PokeNames.SNORUNT]: snorunt,
  [PokeNames.GLALIE]: glalie,
  [PokeNames.SPHEAL]: spheal,
  [PokeNames.SEALEO]: sealeo,
  [PokeNames.WALREIN]: walrein,
  [PokeNames.CLAMPERL]: clamperl,
  [PokeNames.HUNTAIL]: huntail,
  [PokeNames.GOREBYSS]: gorebyss,
  [PokeNames.RELICANTH]: relicanth,
  [PokeNames.LUVDISC]: luvdisc,
  [PokeNames.BAGON]: bagon,
  [PokeNames.SHELGON]: shelgon,
  [PokeNames.SALAMENCE]: salamence,
  [PokeNames.BELDUM]: beldum,
  [PokeNames.METANG]: metang,
  [PokeNames.METAGROSS]: metagross,
  [PokeNames.REGIROCK]: regirock,
  [PokeNames.REGICE]: regice,
  [PokeNames.REGISTEEL]: registeel,
  [PokeNames.LATIAS]: latias,
  [PokeNames.LATIOS]: latios,
  [PokeNames.KYOGRE]: kyogre,
  [PokeNames.GROUDON]: groudon,
  [PokeNames.RAYQUAZA]: rayquaza,
  [PokeNames.JIRACHI]: jirachi,
  [PokeNames.DEOXYS_NORMAL]: deoxys_normal,
  [PokeNames.TURTWIG]: turtwig,
  [PokeNames.GROTLE]: grotle,
  [PokeNames.TORTERRA]: torterra,
  [PokeNames.CHIMCHAR]: chimchar,
  [PokeNames.MONFERNO]: monferno,
  [PokeNames.INFERNAPE]: infernape,
  [PokeNames.PIPLUP]: piplup,
  [PokeNames.PRINPLUP]: prinplup,
  [PokeNames.EMPOLEON]: empoleon,
  [PokeNames.STARLY]: starly,
  [PokeNames.STARAVIA]: staravia,
  [PokeNames.STARAPTOR]: staraptor,
  [PokeNames.BIDOOF]: bidoof,
  [PokeNames.BIBAREL]: bibarel,
  [PokeNames.KRICKETOT]: kricketot,
  [PokeNames.KRICKETUNE]: kricketune,
  [PokeNames.SHINX]: shinx,
  [PokeNames.LUXIO]: luxio,
  [PokeNames.LUXRAY]: luxray,
  [PokeNames.BUDEW]: budew,
  [PokeNames.ROSERADE]: roserade,
  [PokeNames.CRANIDOS]: cranidos,
  [PokeNames.RAMPARDOS]: rampardos,
  [PokeNames.SHIELDON]: shieldon,
  [PokeNames.BASTIODON]: bastiodon,
  [PokeNames.BURMY]: burmy,
  [PokeNames.WORMADAM_PLANT]: wormadam_plant,
  [PokeNames.MOTHIM]: mothim,
  [PokeNames.COMBEE]: combee,
  [PokeNames.VESPIQUEN]: vespiquen,
  [PokeNames.PACHIRISU]: pachirisu,
  [PokeNames.BUIZEL]: buizel,
  [PokeNames.FLOATZEL]: floatzel,
  [PokeNames.CHERUBI]: cherubi,
  [PokeNames.CHERRIM]: cherrim,
  [PokeNames.SHELLOS]: shellos,
  [PokeNames.GASTRODON]: gastrodon,
  [PokeNames.AMBIPOM]: ambipom,
  [PokeNames.DRIFLOON]: drifloon,
  [PokeNames.DRIFBLIM]: drifblim,
  [PokeNames.BUNEARY]: buneary,
  [PokeNames.LOPUNNY]: lopunny,
  [PokeNames.MISMAGIUS]: mismagius,
  [PokeNames.HONCHKROW]: honchkrow,
  [PokeNames.GLAMEOW]: glameow,
  [PokeNames.PURUGLY]: purugly,
  [PokeNames.CHINGLING]: chingling,
  [PokeNames.STUNKY]: stunky,
  [PokeNames.SKUNTANK]: skuntank,
  [PokeNames.BRONZOR]: bronzor,
  [PokeNames.BRONZONG]: bronzong,
  [PokeNames.BONSLY]: bonsly,
  [PokeNames.MIME_JR]: mime_jr,
  [PokeNames.HAPPINY]: happiny,
  [PokeNames.CHATOT]: chatot,
  [PokeNames.SPIRITOMB]: spiritomb,
  [PokeNames.GIBLE]: gible,
  [PokeNames.GABITE]: gabite,
  [PokeNames.GARCHOMP]: garchomp,
  [PokeNames.MUNCHLAX]: munchlax,
  [PokeNames.RIOLU]: riolu,
  [PokeNames.LUCARIO]: lucario,
  [PokeNames.HIPPOPOTAS]: hippopotas,
  [PokeNames.HIPPOWDON]: hippowdon,
  [PokeNames.SKORUPI]: skorupi,
  [PokeNames.DRAPION]: drapion,
  [PokeNames.CROAGUNK]: croagunk,
  [PokeNames.TOXICROAK]: toxicroak,
  [PokeNames.CARNIVINE]: carnivine,
  [PokeNames.FINNEON]: finneon,
  [PokeNames.LUMINEON]: lumineon,
  [PokeNames.MANTYKE]: mantyke,
  [PokeNames.SNOVER]: snover,
  [PokeNames.ABOMASNOW]: abomasnow,
  [PokeNames.WEAVILE]: weavile,
  [PokeNames.MAGNEZONE]: magnezone,
  [PokeNames.LICKILICKY]: lickilicky,
  [PokeNames.RHYPERIOR]: rhyperior,
  [PokeNames.TANGROWTH]: tangrowth,
  [PokeNames.ELECTIVIRE]: electivire,
  [PokeNames.MAGMORTAR]: magmortar,
  [PokeNames.TOGEKISS]: togekiss,
  [PokeNames.YANMEGA]: yanmega,
  [PokeNames.LEAFEON]: leafeon,
  [PokeNames.GLACEON]: glaceon,
  [PokeNames.GLISCOR]: gliscor,
  [PokeNames.MAMOSWINE]: mamoswine,
  [PokeNames.PORYGON_Z]: porygon_z,
  [PokeNames.GALLADE]: gallade,
  [PokeNames.PROBOPASS]: probopass,
  [PokeNames.DUSKNOIR]: dusknoir,
  [PokeNames.FROSLASS]: froslass,
  [PokeNames.ROTOM]: rotom,
  [PokeNames.UXIE]: uxie,
  [PokeNames.MESPRIT]: mesprit,
  [PokeNames.AZELF]: azelf,
  [PokeNames.DIALGA]: dialga,
  [PokeNames.PALKIA]: palkia,
  [PokeNames.HEATRAN]: heatran,
  [PokeNames.REGIGIGAS]: regigigas,
  [PokeNames.GIRATINA_ALTERED]: giratina_altered,
  [PokeNames.CRESSELIA]: cresselia,
  [PokeNames.PHIONE]: phione,
  [PokeNames.MANAPHY]: manaphy,
  [PokeNames.DARKRAI]: darkrai,
  [PokeNames.SHAYMIN_LAND]: shaymin_land,
  [PokeNames.ARCEUS]: arceus,
  [PokeNames.VICTINI]: victini,
  [PokeNames.SNIVY]: snivy,
  [PokeNames.SERVINE]: servine,
  [PokeNames.SERPERIOR]: serperior,
  [PokeNames.TEPIG]: tepig,
  [PokeNames.PIGNITE]: pignite,
  [PokeNames.EMBOAR]: emboar,
  [PokeNames.OSHAWOTT]: oshawott,
  [PokeNames.DEWOTT]: dewott,
  [PokeNames.SAMUROTT]: samurott,
  [PokeNames.PATRAT]: patrat,
  [PokeNames.WATCHOG]: watchog,
  [PokeNames.LILLIPUP]: lillipup,
  [PokeNames.HERDIER]: herdier,
  [PokeNames.STOUTLAND]: stoutland,
  [PokeNames.PURRLOIN]: purrloin,
  [PokeNames.LIEPARD]: liepard,
  [PokeNames.PANSAGE]: pansage,
  [PokeNames.SIMISAGE]: simisage,
  [PokeNames.PANSEAR]: pansear,
  [PokeNames.SIMISEAR]: simisear,
  [PokeNames.PANPOUR]: panpour,
  [PokeNames.SIMIPOUR]: simipour,
  [PokeNames.MUNNA]: munna,
  [PokeNames.MUSHARNA]: musharna,
  [PokeNames.PIDOVE]: pidove,
  [PokeNames.TRANQUILL]: tranquill,
  [PokeNames.UNFEZANT]: unfezant,
  [PokeNames.BLITZLE]: blitzle,
  [PokeNames.ZEBSTRIKA]: zebstrika,
  [PokeNames.ROGGENROLA]: roggenrola,
  [PokeNames.BOLDORE]: boldore,
  [PokeNames.GIGALITH]: gigalith,
  [PokeNames.WOOBAT]: woobat,
  [PokeNames.SWOOBAT]: swoobat,
  [PokeNames.DRILBUR]: drilbur,
  [PokeNames.EXCADRILL]: excadrill,
  [PokeNames.AUDINO]: audino,
  [PokeNames.TIMBURR]: timburr,
  [PokeNames.GURDURR]: gurdurr,
  [PokeNames.CONKELDURR]: conkeldurr,
  [PokeNames.TYMPOLE]: tympole,
  [PokeNames.PALPITOAD]: palpitoad,
  [PokeNames.SEISMITOAD]: seismitoad,
  [PokeNames.THROH]: throh,
  [PokeNames.SAWK]: sawk,
  [PokeNames.SEWADDLE]: sewaddle,
  [PokeNames.SWADLOON]: swadloon,
  [PokeNames.LEAVANNY]: leavanny,
  [PokeNames.VENIPEDE]: venipede,
  [PokeNames.WHIRLIPEDE]: whirlipede,
  [PokeNames.SCOLIPEDE]: scolipede,
  [PokeNames.COTTONEE]: cottonee,
  [PokeNames.WHIMSICOTT]: whimsicott,
  [PokeNames.PETILIL]: petilil,
  [PokeNames.LILLIGANT]: lilligant,
  [PokeNames.BASCULIN_RED_STRIPED]: basculin_red_striped,
  [PokeNames.SANDILE]: sandile,
  [PokeNames.KROKOROK]: krokorok,
  [PokeNames.KROOKODILE]: krookodile,
  [PokeNames.DARUMAKA]: darumaka,
  [PokeNames.DARMANITAN_STANDARD]: darmanitan_standard,
  [PokeNames.MARACTUS]: maractus,
  [PokeNames.DWEBBLE]: dwebble,
  [PokeNames.CRUSTLE]: crustle,
  [PokeNames.SCRAGGY]: scraggy,
  [PokeNames.SCRAFTY]: scrafty,
  [PokeNames.SIGILYPH]: sigilyph,
  [PokeNames.YAMASK]: yamask,
  [PokeNames.COFAGRIGUS]: cofagrigus,
  [PokeNames.TIRTOUGA]: tirtouga,
  [PokeNames.CARRACOSTA]: carracosta,
  [PokeNames.ARCHEN]: archen,
  [PokeNames.ARCHEOPS]: archeops,
  [PokeNames.TRUBBISH]: trubbish,
  [PokeNames.GARBODOR]: garbodor,
  [PokeNames.ZORUA]: zorua,
  [PokeNames.ZOROARK]: zoroark,
  [PokeNames.MINCCINO]: minccino,
  [PokeNames.CINCCINO]: cinccino,
  [PokeNames.GOTHITA]: gothita,
  [PokeNames.GOTHORITA]: gothorita,
  [PokeNames.GOTHITELLE]: gothitelle,
  [PokeNames.SOLOSIS]: solosis,
  [PokeNames.DUOSION]: duosion,
  [PokeNames.REUNICLUS]: reuniclus,
  [PokeNames.DUCKLETT]: ducklett,
  [PokeNames.SWANNA]: swanna,
  [PokeNames.VANILLITE]: vanillite,
  [PokeNames.VANILLISH]: vanillish,
  [PokeNames.VANILLUXE]: vanilluxe,
  [PokeNames.DEERLING]: deerling,
  [PokeNames.SAWSBUCK]: sawsbuck,
  [PokeNames.EMOLGA]: emolga,
  [PokeNames.KARRABLAST]: karrablast,
  [PokeNames.ESCAVALIER]: escavalier,
  [PokeNames.FOONGUS]: foongus,
  [PokeNames.AMOONGUSS]: amoonguss,
  [PokeNames.FRILLISH]: frillish,
  [PokeNames.JELLICENT]: jellicent,
  [PokeNames.ALOMOMOLA]: alomomola,
  [PokeNames.JOLTIK]: joltik,
  [PokeNames.GALVANTULA]: galvantula,
  [PokeNames.FERROSEED]: ferroseed,
  [PokeNames.FERROTHORN]: ferrothorn,
  [PokeNames.KLINK]: klink,
  [PokeNames.KLANG]: klang,
  [PokeNames.KLINKLANG]: klinklang,
  [PokeNames.TYNAMO]: tynamo,
  [PokeNames.EELEKTRIK]: eelektrik,
  [PokeNames.EELEKTROSS]: eelektross,
  [PokeNames.ELGYEM]: elgyem,
  [PokeNames.BEHEEYEM]: beheeyem,
  [PokeNames.LITWICK]: litwick,
  [PokeNames.LAMPENT]: lampent,
  [PokeNames.CHANDELURE]: chandelure,
  [PokeNames.AXEW]: axew,
  [PokeNames.FRAXURE]: fraxure,
  [PokeNames.HAXORUS]: haxorus,
  [PokeNames.CUBCHOO]: cubchoo,
  [PokeNames.BEARTIC]: beartic,
  [PokeNames.CRYOGONAL]: cryogonal,
  [PokeNames.SHELMET]: shelmet,
  [PokeNames.ACCELGOR]: accelgor,
  [PokeNames.STUNFISK]: stunfisk,
  [PokeNames.MIENFOO]: mienfoo,
  [PokeNames.MIENSHAO]: mienshao,
  [PokeNames.DRUDDIGON]: druddigon,
  [PokeNames.GOLETT]: golett,
  [PokeNames.GOLURK]: golurk,
  [PokeNames.PAWNIARD]: pawniard,
  [PokeNames.BISHARP]: bisharp,
  [PokeNames.BOUFFALANT]: bouffalant,
  [PokeNames.RUFFLET]: rufflet,
  [PokeNames.BRAVIARY]: braviary,
  [PokeNames.VULLABY]: vullaby,
  [PokeNames.MANDIBUZZ]: mandibuzz,
  [PokeNames.HEATMOR]: heatmor,
  [PokeNames.DURANT]: durant,
  [PokeNames.DEINO]: deino,
  [PokeNames.ZWEILOUS]: zweilous,
  [PokeNames.HYDREIGON]: hydreigon,
  [PokeNames.LARVESTA]: larvesta,
  [PokeNames.VOLCARONA]: volcarona,
  [PokeNames.COBALION]: cobalion,
  [PokeNames.TERRAKION]: terrakion,
  [PokeNames.VIRIZION]: virizion,
  [PokeNames.TORNADUS_INCARNATE]: tornadus_incarnate,
  [PokeNames.THUNDURUS_INCARNATE]: thundurus_incarnate,
  [PokeNames.RESHIRAM]: reshiram,
  [PokeNames.ZEKROM]: zekrom,
  [PokeNames.LANDORUS_INCARNATE]: landorus_incarnate,
  [PokeNames.KYUREM]: kyurem,
  [PokeNames.KELDEO_ORDINARY]: keldeo_ordinary,
  [PokeNames.MELOETTA_ARIA]: meloetta_aria,
  [PokeNames.GENESECT]: genesect,
  [PokeNames.CHESPIN]: chespin,
  [PokeNames.QUILLADIN]: quilladin,
  [PokeNames.CHESNAUGHT]: chesnaught,
  [PokeNames.FENNEKIN]: fennekin,
  [PokeNames.BRAIXEN]: braixen,
  [PokeNames.DELPHOX]: delphox,
  [PokeNames.FROAKIE]: froakie,
  [PokeNames.FROGADIER]: frogadier,
  [PokeNames.GRENINJA]: greninja,
  [PokeNames.BUNNELBY]: bunnelby,
  [PokeNames.DIGGERSBY]: diggersby,
  [PokeNames.FLETCHLING]: fletchling,
  [PokeNames.FLETCHINDER]: fletchinder,
  [PokeNames.TALONFLAME]: talonflame,
  [PokeNames.SCATTERBUG]: scatterbug,
  [PokeNames.SPEWPA]: spewpa,
  [PokeNames.VIVILLON]: vivillon,
  [PokeNames.LITLEO]: litleo,
  [PokeNames.PYROAR]: pyroar,
  [PokeNames.FLABEBE]: flabebe,
  [PokeNames.FLOETTE]: floette,
  [PokeNames.FLORGES]: florges,
  [PokeNames.SKIDDO]: skiddo,
  [PokeNames.GOGOAT]: gogoat,
  [PokeNames.PANCHAM]: pancham,
  [PokeNames.PANGORO]: pangoro,
  [PokeNames.FURFROU]: furfrou,
  [PokeNames.ESPURR]: espurr,
  [PokeNames.MEOWSTIC_MALE]: meowstic_male,
  [PokeNames.HONEDGE]: honedge,
  [PokeNames.DOUBLADE]: doublade,
  [PokeNames.AEGISLASH_SHIELD]: aegislash_shield,
  [PokeNames.AEGISLASH]: aegislash_blade,
  [PokeNames.SPRITZEE]: spritzee,
  [PokeNames.AROMATISSE]: aromatisse,
  [PokeNames.SWIRLIX]: swirlix,
  [PokeNames.SLURPUFF]: slurpuff,
  [PokeNames.INKAY]: inkay,
  [PokeNames.MALAMAR]: malamar,
  [PokeNames.BINACLE]: binacle,
  [PokeNames.BARBARACLE]: barbaracle,
  [PokeNames.SKRELP]: skrelp,
  [PokeNames.DRAGALGE]: dragalge,
  [PokeNames.CLAUNCHER]: clauncher,
  [PokeNames.CLAWITZER]: clawitzer,
  [PokeNames.HELIOPTILE]: helioptile,
  [PokeNames.HELIOLISK]: heliolisk,
  [PokeNames.TYRUNT]: tyrunt,
  [PokeNames.TYRANTRUM]: tyrantrum,
  [PokeNames.AMAURA]: amaura,
  [PokeNames.AURORUS]: aurorus,
  [PokeNames.SYLVEON]: sylveon,
  [PokeNames.HAWLUCHA]: hawlucha,
  [PokeNames.DEDENNE]: dedenne,
  [PokeNames.CARBINK]: carbink,
  [PokeNames.GOOMY]: goomy,
  [PokeNames.SLIGGOO]: sliggoo,
  [PokeNames.GOODRA]: goodra,
  [PokeNames.KLEFKI]: klefki,
  [PokeNames.PHANTUMP]: phantump,
  [PokeNames.TREVENANT]: trevenant,
  [PokeNames.PUMPKABOO_AVERAGE]: pumpkaboo_average,
  [PokeNames.GOURGEIST_AVERAGE]: gourgeist_average,
  [PokeNames.BERGMITE]: bergmite,
  [PokeNames.AVALUGG]: avalugg,
  [PokeNames.NOIBAT]: noibat,
  [PokeNames.NOIVERN]: noivern,
  [PokeNames.XERNEAS]: xerneas,
  [PokeNames.YVELTAL]: yveltal,
  [PokeNames.ZYGARDE_50]: zygarde_50,
  [PokeNames.DIANCIE]: diancie,
  [PokeNames.HOOPA]: hoopa,
  [PokeNames.VOLCANION]: volcanion,
  [PokeNames.ROWLET]: rowlet,
  [PokeNames.DARTRIX]: dartrix,
  [PokeNames.DECIDUEYE]: decidueye,
  [PokeNames.LITTEN]: litten,
  [PokeNames.TORRACAT]: torracat,
  [PokeNames.INCINEROAR]: incineroar,
  [PokeNames.POPPLIO]: popplio,
  [PokeNames.BRIONNE]: brionne,
  [PokeNames.PRIMARINA]: primarina,
  [PokeNames.PIKIPEK]: pikipek,
  [PokeNames.TRUMBEAK]: trumbeak,
  [PokeNames.TOUCANNON]: toucannon,
  [PokeNames.YUNGOOS]: yungoos,
  [PokeNames.GUMSHOOS]: gumshoos,
  [PokeNames.GRUBBIN]: grubbin,
  [PokeNames.CHARJABUG]: charjabug,
  [PokeNames.VIKAVOLT]: vikavolt,
  [PokeNames.CRABRAWLER]: crabrawler,
  [PokeNames.CRABOMINABLE]: crabominable,
  [PokeNames.ORICORIO_BAILE]: oricorio_baile,
  [PokeNames.CUTIEFLY]: cutiefly,
  [PokeNames.RIBOMBEE]: ribombee,
  [PokeNames.ROCKRUFF]: rockruff,
  [PokeNames.LYCANROC_MIDDAY]: lycanroc_midday,
  [PokeNames.LYCANROC]: lycanroc_midday,
  [PokeNames.WISHIWASHI_SOLO]: wishiwashi_solo,
  [PokeNames.MAREANIE]: mareanie,
  [PokeNames.TOXAPEX]: toxapex,
  [PokeNames.MUDBRAY]: mudbray,
  [PokeNames.MUDSDALE]: mudsdale,
  [PokeNames.DEWPIDER]: dewpider,
  [PokeNames.ARAQUANID]: araquanid,
  [PokeNames.FOMANTIS]: fomantis,
  [PokeNames.LURANTIS]: lurantis,
  [PokeNames.MORELULL]: morelull,
  [PokeNames.SHIINOTIC]: shiinotic,
  [PokeNames.SALANDIT]: salandit,
  [PokeNames.SALAZZLE]: salazzle,
  [PokeNames.STUFFUL]: stufful,
  [PokeNames.BEWEAR]: bewear,
  [PokeNames.BOUNSWEET]: bounsweet,
  [PokeNames.STEENEE]: steenee,
  [PokeNames.TSAREENA]: tsareena,
  [PokeNames.COMFEY]: comfey,
  [PokeNames.ORANGURU]: oranguru,
  [PokeNames.PASSIMIAN]: passimian,
  [PokeNames.WIMPOD]: wimpod,
  [PokeNames.GOLISOPOD]: golisopod,
  [PokeNames.SANDYGAST]: sandygast,
  [PokeNames.PALOSSAND]: palossand,
  [PokeNames.PYUKUMUKU]: pyukumuku,
  [PokeNames.TYPE_NULL]: type_null,
  [PokeNames.SILVALLY]: silvally,
  [PokeNames.MINIOR_RED_METEOR]: minior_red_meteor,
  [PokeNames.KOMALA]: komala,
  [PokeNames.TURTONATOR]: turtonator,
  [PokeNames.TOGEDEMARU]: togedemaru,
  [PokeNames.MIMIKYU_DISGUISED]: mimikyu_disguised,
  [PokeNames.BRUXISH]: bruxish,
  [PokeNames.DRAMPA]: drampa,
  [PokeNames.DHELMISE]: dhelmise,
  [PokeNames.JANGMO_O]: jangmo_o,
  [PokeNames.HAKAMO_O]: hakamo_o,
  [PokeNames.KOMMO_O]: kommo_o,
  [PokeNames.TAPU_KOKO]: tapu_koko,
  [PokeNames.TAPU_LELE]: tapu_lele,
  [PokeNames.TAPU_BULU]: tapu_bulu,
  [PokeNames.TAPU_FINI]: tapu_fini,
  [PokeNames.COSMOG]: cosmog,
  [PokeNames.COSMOEM]: cosmoem,
  [PokeNames.SOLGALEO]: solgaleo,
  [PokeNames.LUNALA]: lunala,
  [PokeNames.NIHILEGO]: nihilego,
  [PokeNames.BUZZWOLE]: buzzwole,
  [PokeNames.PHEROMOSA]: pheromosa,
  [PokeNames.XURKITREE]: xurkitree,
  [PokeNames.CELESTEELA]: celesteela,
  [PokeNames.KARTANA]: kartana,
  [PokeNames.GUZZLORD]: guzzlord,
  [PokeNames.NECROZMA]: necrozma,
  [PokeNames.MAGEARNA]: magearna,
  [PokeNames.MARSHADOW]: marshadow,
  [PokeNames.POIPOLE]: poipole,
  [PokeNames.NAGANADEL]: naganadel,
  [PokeNames.STAKATAKA]: stakataka,
  [PokeNames.BLACEPHALON]: blacephalon,
  [PokeNames.ZERAORA]: zeraora,
  [PokeNames.MELTAN]: meltan,
  [PokeNames.MELMETAL]: melmetal,
  [PokeNames.GROOKEY]: grookey,
  [PokeNames.THWACKEY]: thwackey,
  [PokeNames.RILLABOOM]: rillaboom,
  [PokeNames.SCORBUNNY]: scorbunny,
  [PokeNames.RABOOT]: raboot,
  [PokeNames.CINDERACE]: cinderace,
  [PokeNames.SOBBLE]: sobble,
  [PokeNames.DRIZZILE]: drizzile,
  [PokeNames.INTELEON]: inteleon,
  [PokeNames.SKWOVET]: skwovet,
  [PokeNames.GREEDENT]: greedent,
  [PokeNames.ROOKIDEE]: rookidee,
  [PokeNames.CORVISQUIRE]: corvisquire,
  [PokeNames.CORVIKNIGHT]: corviknight,
  [PokeNames.BLIPBUG]: blipbug,
  [PokeNames.DOTTLER]: dottler,
  [PokeNames.ORBEETLE]: orbeetle,
  [PokeNames.NICKIT]: nickit,
  [PokeNames.THIEVUL]: thievul,
  [PokeNames.GOSSIFLEUR]: gossifleur,
  [PokeNames.ELDEGOSS]: eldegoss,
  [PokeNames.WOOLOO]: wooloo,
  [PokeNames.DUBWOOL]: dubwool,
  [PokeNames.CHEWTLE]: chewtle,
  [PokeNames.DREDNAW]: drednaw,
  [PokeNames.YAMPER]: yamper,
  [PokeNames.BOLTUND]: boltund,
  [PokeNames.ROLYCOLY]: rolycoly,
  [PokeNames.CARKOL]: carkol,
  [PokeNames.COALOSSAL]: coalossal,
  [PokeNames.APPLIN]: applin,
  [PokeNames.FLAPPLE]: flapple,
  [PokeNames.APPLETUN]: appletun,
  [PokeNames.SILICOBRA]: silicobra,
  [PokeNames.SANDACONDA]: sandaconda,
  [PokeNames.CRAMORANT]: cramorant,
  [PokeNames.ARROKUDA]: arrokuda,
  [PokeNames.BARRASKEWDA]: barraskewda,
  [PokeNames.TOXEL]: toxel,
  [PokeNames.TOXTRICITY]: toxtricity,
  [PokeNames.SIZZLIPEDE]: sizzlipede,
  [PokeNames.CENTISKORCH]: centiskorch,
  [PokeNames.CLOBBOPUS]: clobbopus,
  [PokeNames.GRAPPLOCT]: grapploct,
  [PokeNames.SINISTEA]: sinistea,
  [PokeNames.POLTEAGEIST]: polteageist,
  [PokeNames.HATENNA]: hatenna,
  [PokeNames.HATTREM]: hattrem,
  [PokeNames.HATTERENE]: hatterene,
  [PokeNames.IMPIDIMP]: impidimp,
  [PokeNames.MORGREM]: morgrem,
  [PokeNames.GRIMMSNARL]: grimmsnarl,
  [PokeNames.OBSTAGOON]: obstagoon,
  [PokeNames.PERRSERKER]: perrserker,
  [PokeNames.CURSOLA]: cursola,
  [PokeNames.SIRFETCHD]: sirfetchd,
  [PokeNames.MR_RIME]: mr_rime,
  [PokeNames.RUNERIGUS]: runerigus,
  [PokeNames.MILCERY]: milcery,
  [PokeNames.ALCREMIE]: alcremie,
  [PokeNames.FALINKS]: falinks,
  [PokeNames.PINCURCHIN]: pincurchin,
  [PokeNames.SNOM]: snom,
  [PokeNames.FROSMOTH]: frosmoth,
  [PokeNames.STONJOURNER]: stonjourner,
  [PokeNames.EISCUE_ICE]: eiscue_ice,
  [PokeNames.INDEEDEE_MALE]: indeedee_male,
  [PokeNames.MORPEKO_FULL_BELLY]: morpeko_full_belly,
  [PokeNames.CUFANT]: cufant,
  [PokeNames.COPPERAJAH]: copperajah,
  [PokeNames.DRACOZOLT]: dracozolt,
  [PokeNames.ARCTOZOLT]: arctozolt,
  [PokeNames.DRACOVISH]: dracovish,
  [PokeNames.ARCTOVISH]: arctovish,
  [PokeNames.DURALUDON]: duraludon,
  [PokeNames.DREEPY]: dreepy,
  [PokeNames.DRAKLOAK]: drakloak,
  [PokeNames.DRAGAPULT]: dragapult,
  [PokeNames.ZACIAN]: zacian,
  [PokeNames.ZAMAZENTA]: zamazenta,
  [PokeNames.ETERNATUS]: eternatus,
  [PokeNames.KUBFU]: kubfu,
  [PokeNames.URSHIFU_SINGLE_STRIKE]: urshifu_single_strike,
  [PokeNames.ZARUDE]: zarude,
  [PokeNames.REGIELEKI]: regieleki,
  [PokeNames.REGIDRAGO]: regidrago,
  [PokeNames.GLASTRIER]: glastrier,
  [PokeNames.SPECTRIER]: spectrier,
  [PokeNames.CALYREX]: calyrex,
  [PokeNames.WYRDEER]: wyrdeer,
  [PokeNames.KLEAVOR]: kleavor,
  [PokeNames.URSALUNA]: ursaluna,
  [PokeNames.BASCULEGION_MALE]: basculegion_male,
  [PokeNames.SNEASLER]: sneasler,
  [PokeNames.OVERQWIL]: overqwil,
  [PokeNames.ENAMORUS_INCARNATE]: enamorus_incarnate,
  [PokeNames.SPRIGATITO]: sprigatito,
  [PokeNames.FLORAGATO]: floragato,
  [PokeNames.MEOWSCARADA]: meowscarada,
  [PokeNames.FUECOCO]: fuecoco,
  [PokeNames.CROCALOR]: crocalor,
  [PokeNames.SKELEDIRGE]: skeledirge,
  [PokeNames.QUAXLY]: quaxly,
  [PokeNames.QUAXWELL]: quaxwell,
  [PokeNames.QUAQUAVAL]: quaquaval,
  [PokeNames.LECHONK]: lechonk,
  [PokeNames.OINKOLOGNE_MALE]: oinkologne_male,
  [PokeNames.TAROUNTULA]: tarountula,
  [PokeNames.SPIDOPS]: spidops,
  [PokeNames.NYMBLE]: nymble,
  [PokeNames.LOKIX]: lokix,
  [PokeNames.PAWMI]: pawmi,
  [PokeNames.PAWMO]: pawmo,
  [PokeNames.PAWMOT]: pawmot,
  [PokeNames.TANDEMAUS]: tandemaus,
  [PokeNames.MAUSHOLD]: maushold,
  [PokeNames.FIDOUGH]: fidough,
  [PokeNames.DACHSBUN]: dachsbun,
  [PokeNames.SMOLIV]: smoliv,
  [PokeNames.DOLLIV]: dolliv,
  [PokeNames.ARBOLIVA]: arboliva,
  [PokeNames.SQUAWKABILLY_GREEN_PLUMAGE]: squawkabilly_green_plumage,
  [PokeNames.NACLI]: nacli,
  [PokeNames.NACLSTACK]: naclstack,
  [PokeNames.GARGANACL]: garganacl,
  [PokeNames.CHARCADET]: charcadet,
  [PokeNames.ARMAROUGE]: armarouge,
  [PokeNames.CERULEDGE]: ceruledge,
  [PokeNames.TADBULB]: tadbulb,
  [PokeNames.BELLIBOLT]: bellibolt,
  [PokeNames.WATTREL]: wattrel,
  [PokeNames.KILOWATTREL]: kilowattrel,
  [PokeNames.MASCHIFF]: maschiff,
  [PokeNames.MABOSSTIFF]: mabosstiff,
  [PokeNames.SHROODLE]: shroodle,
  [PokeNames.GRAFAIAI]: grafaiai,
  [PokeNames.BRAMBLIN]: bramblin,
  [PokeNames.BRAMBLEGHAST]: brambleghast,
  [PokeNames.TOEDSCOOL]: toedscool,
  [PokeNames.TOEDSCRUEL]: toedscruel,
  [PokeNames.KLAWF]: klawf,
  [PokeNames.CAPSAKID]: capsakid,
  [PokeNames.SCOVILLAIN]: scovillain,
  [PokeNames.RELLOR]: rellor,
  [PokeNames.RABSCA]: rabsca,
  [PokeNames.FLITTLE]: flittle,
  [PokeNames.ESPATHRA]: espathra,
  [PokeNames.TINKATINK]: tinkatink,
  [PokeNames.TINKATUFF]: tinkatuff,
  [PokeNames.TINKATON]: tinkaton,
  [PokeNames.WIGLETT]: wiglett,
  [PokeNames.WUGTRIO]: wugtrio,
  [PokeNames.BOMBIRDIER]: bombirdier,
  [PokeNames.FINIZEN]: finizen,
  [PokeNames.PALAFIN_ZERO]: palafin_zero,
  [PokeNames.VAROOM]: varoom,
  [PokeNames.REVAVROOM]: revavroom,
  [PokeNames.CYCLIZAR]: cyclizar,
  [PokeNames.ORTHWORM]: orthworm,
  [PokeNames.GLIMMET]: glimmet,
  [PokeNames.GLIMMORA]: glimmora,
  [PokeNames.GREAVARD]: greavard,
  [PokeNames.HOUNDSTONE]: houndstone,
  [PokeNames.FLAMIGO]: flamigo,
  [PokeNames.CETODDLE]: cetoddle,
  [PokeNames.CETITAN]: cetitan,
  [PokeNames.VELUZA]: veluza,
  [PokeNames.DONDOZO]: dondozo,
  [PokeNames.TATSUGIRI_CURLY]: tatsugiri_curly,
  [PokeNames.ANNIHILAPE]: annihilape,
  [PokeNames.CLODSIRE]: clodsire,
  [PokeNames.FARIGIRAF]: farigiraf,
  [PokeNames.DUDUNSPARCE_TWO_SEGMENT]: dudunsparce_two_segment,
  [PokeNames.KINGAMBIT]: kingambit,
  [PokeNames.GREAT_TUSK]: great_tusk,
  [PokeNames.SCREAM_TAIL]: scream_tail,
  [PokeNames.BRUTE_BONNET]: brute_bonnet,
  [PokeNames.FLUTTER_MANE]: flutter_mane,
  [PokeNames.SLITHER_WING]: slither_wing,
  [PokeNames.SANDY_SHOCKS]: sandy_shocks,
  [PokeNames.IRON_TREADS]: iron_treads,
  [PokeNames.IRON_BUNDLE]: iron_bundle,
  [PokeNames.IRON_HANDS]: iron_hands,
  [PokeNames.IRON_JUGULIS]: iron_jugulis,
  [PokeNames.IRON_MOTH]: iron_moth,
  [PokeNames.IRON_THORNS]: iron_thorns,
  [PokeNames.FRIGIBAX]: frigibax,
  [PokeNames.ARCTIBAX]: arctibax,
  [PokeNames.BAXCALIBUR]: baxcalibur,
  [PokeNames.GIMMIGHOUL]: gimmighoul,
  [PokeNames.GHOLDENGO]: gholdengo,
  [PokeNames.WO_CHIEN]: wo_chien,
  [PokeNames.CHIEN_PAO]: chien_pao,
  [PokeNames.TING_LU]: ting_lu,
  [PokeNames.CHI_YU]: chi_yu,
  [PokeNames.ROARING_MOON]: roaring_moon,
  [PokeNames.IRON_VALIANT]: iron_valiant,
  [PokeNames.KORAIDON]: koraidon,
  [PokeNames.MIRAIDON]: miraidon,
  [PokeNames.WALKING_WAKE]: walking_wake,
  [PokeNames.IRON_LEAVES]: iron_leaves,
  [PokeNames.DIPPLIN]: dipplin,
  [PokeNames.POLTCHAGEIST]: poltchageist,
  [PokeNames.SINISTCHA]: sinistcha,
  [PokeNames.OKIDOGI]: okidogi,
  [PokeNames.MUNKIDORI]: munkidori,
  [PokeNames.FEZANDIPITI]: fezandipiti,
  [PokeNames.OGERPON]: ogerpon,
  [PokeNames.ARCHALUDON]: archaludon,
  [PokeNames.HYDRAPPLE]: hydrapple,
  [PokeNames.GOUGING_FIRE]: gouging_fire,
  [PokeNames.RAGING_BOLT]: raging_bolt,
  [PokeNames.IRON_BOULDER]: iron_boulder,
  [PokeNames.IRON_CROWN]: iron_crown,
  [PokeNames.TERAPAGOS]: terapagos,
  [PokeNames.PECHARUNT]: pecharunt,
  [PokeNames.DEOXYS_ATTACK]: deoxys_attack,
  [PokeNames.DEOXYS_DEFENSE]: deoxys_defense,
  [PokeNames.DEOXYS_SPEED]: deoxys_speed,
  [PokeNames.WORMADAM_SANDY]: wormadam_sandy,
  [PokeNames.WORMADAM_TRASH]: wormadam_trash,
  [PokeNames.SHAYMIN_SKY]: shaymin_sky,
  [PokeNames.GIRATINA_ORIGIN]: giratina_origin,
  [PokeNames.ROTOM_HEAT]: rotom_heat,
  [PokeNames.ROTOM_WASH]: rotom_wash,
  [PokeNames.ROTOM_FROST]: rotom_frost,
  [PokeNames.ROTOM_FAN]: rotom_fan,
  [PokeNames.ROTOM_MOW]: rotom_mow,
  [PokeNames.CASTFORM_SUNNY]: castform_sunny,
  [PokeNames.CASTFORM_RAINY]: castform_rainy,
  [PokeNames.CASTFORM_SNOWY]: castform_snowy,
  [PokeNames.BASCULIN_BLUE_STRIPED]: basculin_blue_striped,
  [PokeNames.DARMANITAN_ZEN]: darmanitan_zen,
  [PokeNames.MELOETTA_PIROUETTE]: meloetta_pirouette,
  [PokeNames.TORNADUS_THERIAN]: tornadus_therian,
  [PokeNames.THUNDURUS_THERIAN]: thundurus_therian,
  [PokeNames.LANDORUS_THERIAN]: landorus_therian,
  [PokeNames.KYUREM_BLACK]: kyurem_black,
  [PokeNames.KYUREM_WHITE]: kyurem_white,
  [PokeNames.KELDEO_RESOLUTE]: keldeo_resolute,
  [PokeNames.MEOWSTIC_FEMALE]: meowstic_female,
  [PokeNames.AEGISLASH_BLADE]: aegislash_blade,
  [PokeNames.PUMPKABOO_SMALL]: pumpkaboo_small,
  [PokeNames.PUMPKABOO_LARGE]: pumpkaboo_large,
  [PokeNames.PUMPKABOO_SUPER]: pumpkaboo_super,
  [PokeNames.GOURGEIST_SMALL]: gourgeist_small,
  [PokeNames.GOURGEIST_LARGE]: gourgeist_large,
  [PokeNames.GOURGEIST_SUPER]: gourgeist_super,
  [PokeNames.VENUSAUR_MEGA]: venusaur_mega,
  [PokeNames.CHARIZARD_MEGA_X]: charizard_mega_x,
  [PokeNames.CHARIZARD_MEGA_Y]: charizard_mega_y,
  [PokeNames.BLASTOISE_MEGA]: blastoise_mega,
  [PokeNames.ALAKAZAM_MEGA]: alakazam_mega,
  [PokeNames.GENGAR_MEGA]: gengar_mega,
  [PokeNames.KANGASKHAN_MEGA]: kangaskhan_mega,
  [PokeNames.PINSIR_MEGA]: pinsir_mega,
  [PokeNames.GYARADOS_MEGA]: gyarados_mega,
  [PokeNames.AERODACTYL_MEGA]: aerodactyl_mega,
  [PokeNames.MEWTWO_MEGA_X]: mewtwo_mega_x,
  [PokeNames.MEWTWO_MEGA_Y]: mewtwo_mega_y,
  [PokeNames.AMPHAROS_MEGA]: ampharos_mega,
  [PokeNames.SCIZOR_MEGA]: scizor_mega,
  [PokeNames.HERACROSS_MEGA]: heracross_mega,
  [PokeNames.HOUNDOOM_MEGA]: houndoom_mega,
  [PokeNames.TYRANITAR_MEGA]: tyranitar_mega,
  [PokeNames.BLAZIKEN_MEGA]: blaziken_mega,
  [PokeNames.GARDEVOIR_MEGA]: gardevoir_mega,
  [PokeNames.MAWILE_MEGA]: mawile_mega,
  [PokeNames.AGGRON_MEGA]: aggron_mega,
  [PokeNames.MEDICHAM_MEGA]: medicham_mega,
  [PokeNames.MANECTRIC_MEGA]: manectric_mega,
  [PokeNames.BANETTE_MEGA]: banette_mega,
  [PokeNames.ABSOL_MEGA]: absol_mega,
  [PokeNames.GARCHOMP_MEGA]: garchomp_mega,
  [PokeNames.LUCARIO_MEGA]: lucario_mega,
  [PokeNames.ABOMASNOW_MEGA]: abomasnow_mega,
  [PokeNames.FLOETTE_ETERNAL]: floette_eternal,
  [PokeNames.LATIAS_MEGA]: latias_mega,
  [PokeNames.LATIOS_MEGA]: latios_mega,
  [PokeNames.SWAMPERT_MEGA]: swampert_mega,
  [PokeNames.SCEPTILE_MEGA]: sceptile_mega,
  [PokeNames.SABLEYE_MEGA]: sableye_mega,
  [PokeNames.ALTARIA_MEGA]: altaria_mega,
  [PokeNames.GALLADE_MEGA]: gallade_mega,
  [PokeNames.AUDINO_MEGA]: audino_mega,
  [PokeNames.SHARPEDO_MEGA]: sharpedo_mega,
  [PokeNames.SLOWBRO_MEGA]: slowbro_mega,
  [PokeNames.STEELIX_MEGA]: steelix_mega,
  [PokeNames.PIDGEOT_MEGA]: pidgeot_mega,
  [PokeNames.GLALIE_MEGA]: glalie_mega,
  [PokeNames.DIANCIE_MEGA]: diancie_mega,
  [PokeNames.METAGROSS_MEGA]: metagross_mega,
  [PokeNames.KYOGRE_PRIMAL]: kyogre_primal,
  [PokeNames.GROUDON_PRIMAL]: groudon_primal,
  [PokeNames.RAYQUAZA_MEGA]: rayquaza_mega,
  [PokeNames.HOOPA_UNBOUND]: hoopa_unbound,
  [PokeNames.CAMERUPT_MEGA]: camerupt_mega,
  [PokeNames.LOPUNNY_MEGA]: lopunny_mega,
  [PokeNames.SALAMENCE_MEGA]: salamence_mega,
  [PokeNames.BEEDRILL_MEGA]: beedrill_mega,
  [PokeNames.RATTATA_ALOLA]: rattata_alola,
  [PokeNames.RATICATE_ALOLA]: raticate_alola,
  [PokeNames.RAICHU_ALOLA]: raichu_alola,
  [PokeNames.SANDSHREW_ALOLA]: sandshrew_alola,
  [PokeNames.SANDSLASH_ALOLA]: sandslash_alola,
  [PokeNames.VULPIX_ALOLA]: vulpix_alola,
  [PokeNames.NINETALES_ALOLA]: ninetales_alola,
  [PokeNames.DIGLETT_ALOLA]: diglett_alola,
  [PokeNames.DUGTRIO_ALOLA]: dugtrio_alola,
  [PokeNames.MEOWTH_ALOLA]: meowth_alola,
  [PokeNames.PERSIAN_ALOLA]: persian_alola,
  [PokeNames.GEODUDE_ALOLA]: geodude_alola,
  [PokeNames.GRAVELER_ALOLA]: graveler_alola,
  [PokeNames.GOLEM_ALOLA]: golem_alola,
  [PokeNames.GRIMER_ALOLA]: grimer_alola,
  [PokeNames.MUK_ALOLA]: muk_alola,
  [PokeNames.EXEGGUTOR_ALOLA]: exeggutor_alola,
  [PokeNames.MAROWAK_ALOLA]: marowak_alola,
  [PokeNames.ZYGARDE_10_POWER_CONSTRUCT]: zygarde_10_power_construct,
  [PokeNames.ZYGARDE_50_POWER_CONSTRUCT]: zygarde_50_power_construct,
  [PokeNames.ZYGARDE_COMPLETE]: zygarde_complete,
  [PokeNames.ORICORIO_POM_POM]: oricorio_pom_pom,
  [PokeNames.ORICORIO_PAU]: oricorio_pau,
  [PokeNames.ORICORIO_SENSU]: oricorio_sensu,
  [PokeNames.LYCANROC_MIDNIGHT]: lycanroc_midnight,
  [PokeNames.WISHIWASHI_SCHOOL]: wishiwashi_school,
  [PokeNames.MINIOR_ORANGE_METEOR]: minior_orange_meteor,
  [PokeNames.MINIOR_YELLOW_METEOR]: minior_yellow_meteor,
  [PokeNames.MINIOR_GREEN_METEOR]: minior_green_meteor,
  [PokeNames.MINIOR_BLUE_METEOR]: minior_blue_meteor,
  [PokeNames.MINIOR_INDIGO_METEOR]: minior_indigo_meteor,
  [PokeNames.MINIOR_VIOLET_METEOR]: minior_violet_meteor,
  [PokeNames.MINIOR_RED]: minior_red,
  [PokeNames.MINIOR_ORANGE]: minior_orange,
  [PokeNames.MINIOR_YELLOW]: minior_yellow,
  [PokeNames.MINIOR_GREEN]: minior_green,
  [PokeNames.MINIOR_BLUE]: minior_blue,
  [PokeNames.MINIOR_INDIGO]: minior_indigo,
  [PokeNames.MINIOR_VIOLET]: minior_violet,
  [PokeNames.MIMIKYU_BUSTED]: mimikyu_busted,
  [PokeNames.MAGEARNA_ORIGINAL]: magearna_original,
  [PokeNames.PIKACHU_PARTNER_CAP]: pikachu_partner_cap,
  [PokeNames.ROCKRUFF_OWN_TEMPO]: rockruff_own_tempo,
  [PokeNames.LYCANROC_DUSK]: lycanroc_dusk,
  [PokeNames.NECROZMA_DUSK]: necrozma_dusk,
  [PokeNames.NECROZMA_DAWN]: necrozma_dawn,
  [PokeNames.NECROZMA_ULTRA]: necrozma_ultra,
  [PokeNames.PIKACHU_STARTER]: pikachu_starter,
  [PokeNames.EEVEE_STARTER]: eevee_starter,
  [PokeNames.PIKACHU_WORLD_CAP]: pikachu_world_cap,
  [PokeNames.MEOWTH_GALAR]: meowth_galar,
  [PokeNames.PONYTA_GALAR]: ponyta_galar,
  [PokeNames.RAPIDASH_GALAR]: rapidash_galar,
  [PokeNames.SLOWPOKE_GALAR]: slowpoke_galar,
  [PokeNames.SLOWBRO_GALAR]: slowbro_galar,
  [PokeNames.FARFETCHD_GALAR]: farfetchd_galar,
  [PokeNames.WEEZING_GALAR]: weezing_galar,
  [PokeNames.MR_MIME_GALAR]: mr_mime_galar,
  [PokeNames.ARTICUNO_GALAR]: articuno_galar,
  [PokeNames.ZAPDOS_GALAR]: zapdos_galar,
  [PokeNames.MOLTRES_GALAR]: moltres_galar,
  [PokeNames.SLOWKING_GALAR]: slowking_galar,
  [PokeNames.CORSOLA_GALAR]: corsola_galar,
  [PokeNames.ZIGZAGOON_GALAR]: zigzagoon_galar,
  [PokeNames.LINOONE_GALAR]: linoone_galar,
  [PokeNames.DARUMAKA_GALAR]: darumaka_galar,
  [PokeNames.DARMANITAN_GALAR_STANDARD]: darmanitan_galar_standard,
  [PokeNames.DARMANITAN_GALAR_ZEN]: darmanitan_galar_zen,
  [PokeNames.YAMASK_GALAR]: yamask_galar,
  [PokeNames.STUNFISK_GALAR]: stunfisk_galar,
  [PokeNames.ZYGARDE_10]: zygarde_10,
  [PokeNames.CRAMORANT_GULPING]: cramorant_gulping,
  [PokeNames.CRAMORANT_GORGING]: cramorant_gorging,
  [PokeNames.TOXTRICITY_LOW_KEY]: toxtricity_low_key,
  [PokeNames.EISCUE_NOICE]: eiscue_noice,
  [PokeNames.INDEEDEE_FEMALE]: indeedee_female,
  [PokeNames.MORPEKO_HANGRY]: morpeko_hangry,
  [PokeNames.ZACIAN_CROWNED]: zacian_crowned,
  [PokeNames.ZAMAZENTA_CROWNED]: zamazenta_crowned,
  [PokeNames.ETERNATUS_ETERNAMAX]: eternatus_eternamax,
  [PokeNames.URSHIFU_RAPID_STRIKE]: urshifu_rapid_strike,
  [PokeNames.ZARUDE_DADA]: zarude_dada,
  [PokeNames.CALYREX_ICE]: calyrex_ice,
  [PokeNames.CALYREX_SHADOW]: calyrex_shadow,
  [PokeNames.VENUSAUR_GMAX]: venusaur_gmax,
  [PokeNames.CHARIZARD_GMAX]: charizard_gmax,
  [PokeNames.BLASTOISE_GMAX]: blastoise_gmax,
  [PokeNames.BUTTERFREE_GMAX]: butterfree_gmax,
  [PokeNames.PIKACHU_GMAX]: pikachu_gmax,
  [PokeNames.MEOWTH_GMAX]: meowth_gmax,
  [PokeNames.MACHAMP_GMAX]: machamp_gmax,
  [PokeNames.GENGAR_GMAX]: gengar_gmax,
  [PokeNames.KINGLER_GMAX]: kingler_gmax,
  [PokeNames.LAPRAS_GMAX]: lapras_gmax,
  [PokeNames.EEVEE_GMAX]: eevee_gmax,
  [PokeNames.SNORLAX_GMAX]: snorlax_gmax,
  [PokeNames.GARBODOR_GMAX]: garbodor_gmax,
  [PokeNames.MELMETAL_GMAX]: melmetal_gmax,
  [PokeNames.RILLABOOM_GMAX]: rillaboom_gmax,
  [PokeNames.CINDERACE_GMAX]: cinderace_gmax,
  [PokeNames.INTELEON_GMAX]: inteleon_gmax,
  [PokeNames.CORVIKNIGHT_GMAX]: corviknight_gmax,
  [PokeNames.ORBEETLE_GMAX]: orbeetle_gmax,
  [PokeNames.DREDNAW_GMAX]: drednaw_gmax,
  [PokeNames.COALOSSAL_GMAX]: coalossal_gmax,
  [PokeNames.FLAPPLE_GMAX]: flapple_gmax,
  [PokeNames.APPLETUN_GMAX]: appletun_gmax,
  [PokeNames.SANDACONDA_GMAX]: sandaconda_gmax,
  [PokeNames.TOXTRICITY_AMPED_GMAX]: toxtricity_amped_gmax,
  [PokeNames.CENTISKORCH_GMAX]: centiskorch_gmax,
  [PokeNames.HATTERENE_GMAX]: hatterene_gmax,
  [PokeNames.GRIMMSNARL_GMAX]: grimmsnarl_gmax,
  [PokeNames.ALCREMIE_GMAX]: alcremie_gmax,
  [PokeNames.COPPERAJAH_GMAX]: copperajah_gmax,
  [PokeNames.DURALUDON_GMAX]: duraludon_gmax,
  [PokeNames.URSHIFU_SINGLE_STRIKE_GMAX]: urshifu_single_strike_gmax,
  [PokeNames.URSHIFU_RAPID_STRIKE_GMAX]: urshifu_rapid_strike_gmax,
  [PokeNames.TOXTRICITY_LOW_KEY_GMAX]: toxtricity_low_key_gmax,
  [PokeNames.GROWLITHE_HISUI]: growlithe_hisui,
  [PokeNames.ARCANINE_HISUI]: arcanine_hisui,
  [PokeNames.VOLTORB_HISUI]: voltorb_hisui,
  [PokeNames.ELECTRODE_HISUI]: electrode_hisui,
  [PokeNames.TYPHLOSION_HISUI]: typhlosion_hisui,
  [PokeNames.QWILFISH_HISUI]: qwilfish_hisui,
  [PokeNames.SNEASEL_HISUI]: sneasel_hisui,
  [PokeNames.SAMUROTT_HISUI]: samurott_hisui,
  [PokeNames.LILLIGANT_HISUI]: lilligant_hisui,
  [PokeNames.ZORUA_HISUI]: zorua_hisui,
  [PokeNames.ZOROARK_HISUI]: zoroark_hisui,
  [PokeNames.BRAVIARY_HISUI]: braviary_hisui,
  [PokeNames.SLIGGOO_HISUI]: sliggoo_hisui,
  [PokeNames.GOODRA_HISUI]: goodra_hisui,
  [PokeNames.AVALUGG_HISUI]: avalugg_hisui,
  [PokeNames.DECIDUEYE_HISUI]: decidueye_hisui,
  [PokeNames.DIALGA_ORIGIN]: dialga_origin,
  [PokeNames.PALKIA_ORIGIN]: palkia_origin,
  [PokeNames.BASCULIN_WHITE_STRIPED]: basculin_white_striped,
  [PokeNames.BASCULEGION_FEMALE]: basculegion_female,
  [PokeNames.ENAMORUS_THERIAN]: enamorus_therian,
  [PokeNames.TAUROS_PALDEA_COMBAT_BREED]: tauros_paldea_combat_breed,
  [PokeNames.TAUROS_PALDEA_BLAZE_BREED]: tauros_paldea_blaze_breed,
  [PokeNames.TAUROS_PALDEA_AQUA_BREED]: tauros_paldea_aqua_breed,
  [PokeNames.WOOPER_PALDEA]: wooper_paldea,
  [PokeNames.OINKOLOGNE_FEMALE]: oinkologne_female,
  [PokeNames.DUDUNSPARCE_THREE_SEGMENT]: dudunsparce_three_segment,
  [PokeNames.DUDUNSPARCE]: dudunsparce_three_segment,
  [PokeNames.PALAFIN_HERO]: palafin_hero,
  [PokeNames.MAUSHOLD_FAMILY_OF_THREE]: maushold_family_of_three,
  [PokeNames.TATSUGIRI_DROOPY]: tatsugiri_droopy,
  [PokeNames.TATSUGIRI_STRETCHY]: tatsugiri_stretchy,
  [PokeNames.SQUAWKABILLY_BLUE_PLUMAGE]: squawkabilly_blue_plumage,
  [PokeNames.SQUAWKABILLY_YELLOW_PLUMAGE]: squawkabilly_yellow_plumage,
  [PokeNames.SQUAWKABILLY_WHITE_PLUMAGE]: squawkabilly_white_plumage,
  [PokeNames.GIMMIGHOUL_ROAMING]: gimmighoul_roaming,
  [PokeNames.KORAIDON_LIMITED_BUILD]: koraidon_limited_build,
  [PokeNames.KORAIDON_SPRINTING_BUILD]: koraidon_sprinting_build,
  [PokeNames.KORAIDON_SWIMMING_BUILD]: koraidon_swimming_build,
  [PokeNames.KORAIDON_GLIDING_BUILD]: koraidon_gliding_build,
  [PokeNames.MIRAIDON_LOW_POWER_MODE]: miraidon_low_power_mode,
  [PokeNames.MIRAIDON_DRIVE_MODE]: miraidon_drive_mode,
  [PokeNames.MIRAIDON_AQUATIC_MODE]: miraidon_aquatic_mode,
  [PokeNames.MIRAIDON_GLIDE_MODE]: miraidon_glide_mode,
  [PokeNames.URSALUNA_BLOODMOON]: ursaluna_bloodmoon,
  [PokeNames.OGERPON_WELLSPRING_MASK]: ogerpon_wellspring_mask,
  [PokeNames.OGERPON_HEARTHFLAME_MASK]: ogerpon_hearthflame_mask,
  [PokeNames.OGERPON_CORNERSTONE_MASK]: ogerpon_cornerstone_mask,
  [PokeNames.TERAPAGOS_TERASTAL]: terapagos_terastal,
  [PokeNames.TERAPAGOS_STELLAR]: terapagos_stellar,
};
